import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  UUID: any;
};

export type ActionAssignmentResult = {
  __typename?: 'ActionAssignmentResult';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActionRoleAssignment = {
  __typename?: 'ActionRoleAssignment';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
};

export type ActionRoleAssignmentFilterInput = {
  action?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ActionRoleAssignmentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ActionRoleAssignmentFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<UuidOperationFilterInput>;
};

export type ActionRoleAssignmentInput = {
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  role?: InputMaybe<RoleInput>;
  roleId: Scalars['UUID'];
};

export type ActionSyncResult = {
  __typename?: 'ActionSyncResult';
  alreadyExist: Array<Scalars['String']>;
  assignmentsDeleted: Scalars['Int'];
  created: Array<AuthAction>;
  deleted: Array<Scalars['String']>;
  totalDiscovered: Scalars['Int'];
};

export type AdminMemo = {
  __typename?: 'AdminMemo';
  admin?: Maybe<User>;
  adminId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  operatorLabel?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

export type AdminMemoFilterInput = {
  admin?: InputMaybe<UserFilterInput>;
  adminId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<AdminMemoFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  operatorLabel?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminMemoFilterInput>>;
  text?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type AdminMemoInput = {
  admin?: InputMaybe<UserInput>;
  adminId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  operatorLabel?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  user?: InputMaybe<UserInput>;
  userId: Scalars['UUID'];
};

export type AdminMemoSortInput = {
  admin?: InputMaybe<UserSortInput>;
  adminId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  operatorLabel?: InputMaybe<SortEnumType>;
  text?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum ApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ApprovalStatusOperationFilterInput = {
  equals?: InputMaybe<ApprovalStatus>;
  in?: InputMaybe<Array<ApprovalStatus>>;
  neq?: InputMaybe<ApprovalStatus>;
  nin?: InputMaybe<Array<ApprovalStatus>>;
};

export type AuthAction = {
  __typename?: 'AuthAction';
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
};

export type AuthActionMutationResult = {
  __typename?: 'AuthActionMutationResult';
  authAction?: Maybe<AuthAction>;
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AuthenticatePayload = {
  __typename?: 'AuthenticatePayload';
  isAuthenticated: Scalars['Boolean'];
  jwtToken: Scalars['String'];
};

export type AuthorizationAudit = {
  __typename?: 'AuthorizationAudit';
  actionType: Scalars['String'];
  actorId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  diff?: Maybe<Scalars['String']>;
  entity: Scalars['String'];
  entityId: Scalars['UUID'];
  id: Scalars['UUID'];
};

export type BanMapResult = {
  __typename?: 'BanMapResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BooleanOperationFilterInput = {
  equals?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type CombineQueue = {
  __typename?: 'CombineQueue';
  id: Scalars['UUID'];
  joinedAt: Scalars['DateTime'];
  /** @deprecated Reserved for future regional routing; not used in v1 */
  region?: Maybe<Scalars['String']>;
  status: QueueStatus;
  tier: Tier;
  tierId: Scalars['UUID'];
  user: User;
  userId: Scalars['UUID'];
};

export type CombineQueueStatus = {
  __typename?: 'CombineQueueStatus';
  estimatedWaitTime?: Maybe<Scalars['Int']>;
  isQueued: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  queuedAt?: Maybe<Scalars['DateTime']>;
  tier?: Maybe<Tier>;
};

export type CreateAuthActionInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type CreateFranchiseInput = {
  assistantGeneralManagerId?: InputMaybe<Scalars['UUID']>;
  generalManagerId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type CreateRoleInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateSeasonInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  endsAt: Scalars['DateTime'];
  seasonNumber: Scalars['Int'];
  startsAt: Scalars['DateTime'];
  tag: Scalars['String'];
  visibleFrom?: InputMaybe<Scalars['DateTime']>;
  visibleTo?: InputMaybe<Scalars['DateTime']>;
};

export type CreateStaffPositionInput = {
  displayName: Scalars['String'];
  positionCategory: Scalars['String'];
  positionCode: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
};

export type CreateTransactionInput = {
  submitterId: Scalars['UUID'];
  submittingFranchiseId: Scalars['UUID'];
  tradePartnerFranchiseId?: InputMaybe<Scalars['UUID']>;
  transactionItems: Array<TransactionItemInput>;
  transactionType: TransactionType;
};

export type DateTimeOperationFilterInput = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DiscoveredAction = {
  __typename?: 'DiscoveredAction';
  category?: Maybe<Scalars['String']>;
  className: Scalars['String'];
  key: Scalars['String'];
  methodName: Scalars['String'];
};

export type DraftBoard = {
  __typename?: 'DraftBoard';
  draftPicks: Array<DraftPick>;
  id: Scalars['UUID'];
  roundSize: Scalars['Int'];
  seasonTier: SeasonTier;
  seasonTierId: Scalars['UUID'];
};

export type DraftPick = {
  __typename?: 'DraftPick';
  draftBoard: DraftBoard;
  draftBoardId: Scalars['UUID'];
  draftee: User;
  drafteeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isKeeper: Scalars['Boolean'];
  pickOwner: Team;
  pickOwnerId: Scalars['UUID'];
};

export type FloatOperationFilterInput = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type Franchise = {
  __typename?: 'Franchise';
  AGM?: Maybe<User>;
  AGMStaffPosition?: Maybe<StaffPosition>;
  GM?: Maybe<User>;
  GMStaffPosition?: Maybe<StaffPosition>;
  Staff?: Maybe<Array<Maybe<StaffUser>>>;
  active: Scalars['Boolean'];
  id: Scalars['UUID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
};

export type FranchiseFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FranchiseFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FranchiseFilterInput>>;
  prefix?: InputMaybe<StringOperationFilterInput>;
};

export type FranchiseInput = {
  active: Scalars['Boolean'];
  id: Scalars['UUID'];
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  prefix: Scalars['String'];
};

export type FranchiseSortInput = {
  active?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  logoUrl?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  prefix?: InputMaybe<SortEnumType>;
};

export type FranchiseStaff = {
  __typename?: 'FranchiseStaff';
  franchise: Franchise;
  franchiseId: Scalars['UUID'];
  id: Scalars['UUID'];
  position: StaffPosition;
  positionId: Scalars['UUID'];
  user: User;
  userId: Scalars['UUID'];
};

/** A segment of a collection. */
export type FranchisesCollectionSegment = {
  __typename?: 'FranchisesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Franchise>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Game = {
  __typename?: 'Game';
  awayTeamScore: Scalars['Int'];
  demoUrl?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  gameSeries?: Maybe<GameSeries>;
  gameSeriesId?: Maybe<Scalars['UUID']>;
  homeTeamScore: Scalars['Int'];
  id: Scalars['UUID'];
  lobby?: Maybe<MatchLobby>;
  lobbyId?: Maybe<Scalars['UUID']>;
  map: Scalars['String'];
  matchType: MatchType;
  playerStats?: Maybe<Array<Maybe<PlayerMatchStats>>>;
  ratingsProcessed: Scalars['Boolean'];
  scheduledTime?: Maybe<Scalars['DateTime']>;
  server?: Maybe<GameServer>;
  serverId?: Maybe<Scalars['UUID']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  tier?: Maybe<Tier>;
  tierId?: Maybe<Scalars['UUID']>;
  winningTeam?: Maybe<PlayerTeam>;
};

export type GameFilterInput = {
  and?: InputMaybe<Array<GameFilterInput>>;
  awayTeamScore?: InputMaybe<IntOperationFilterInput>;
  demoUrl?: InputMaybe<StringOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  gameSeries?: InputMaybe<GameSeriesFilterInput>;
  gameSeriesId?: InputMaybe<UuidOperationFilterInput>;
  homeTeamScore?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lobby?: InputMaybe<MatchLobbyFilterInput>;
  lobbyId?: InputMaybe<UuidOperationFilterInput>;
  map?: InputMaybe<StringOperationFilterInput>;
  matchType?: InputMaybe<MatchTypeOperationFilterInput>;
  or?: InputMaybe<Array<GameFilterInput>>;
  playerStats?: InputMaybe<ListFilterInputTypeOfPlayerMatchStatsFilterInput>;
  ratingsProcessed?: InputMaybe<BooleanOperationFilterInput>;
  scheduledTime?: InputMaybe<DateTimeOperationFilterInput>;
  server?: InputMaybe<GameServerFilterInput>;
  serverId?: InputMaybe<UuidOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tier?: InputMaybe<TierFilterInput>;
  tierId?: InputMaybe<UuidOperationFilterInput>;
  winningTeam?: InputMaybe<NullableOfPlayerTeamOperationFilterInput>;
};

export type GameSeries = {
  __typename?: 'GameSeries';
  awayTeam?: Maybe<Team>;
  awayTeamId?: Maybe<Scalars['UUID']>;
  endTime?: Maybe<Scalars['DateTime']>;
  games?: Maybe<Array<Maybe<Game>>>;
  homeTeam?: Maybe<Team>;
  homeTeamId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  lobby?: Maybe<MatchLobby>;
  lobbyId?: Maybe<Scalars['UUID']>;
  matchType: MatchType;
  maxGames: Scalars['Int'];
  scheduledStartTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  tier?: Maybe<Tier>;
  tierId?: Maybe<Scalars['UUID']>;
};

export type GameSeriesFilterInput = {
  and?: InputMaybe<Array<GameSeriesFilterInput>>;
  awayTeam?: InputMaybe<TeamFilterInput>;
  awayTeamId?: InputMaybe<UuidOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  games?: InputMaybe<ListFilterInputTypeOfGameFilterInput>;
  homeTeam?: InputMaybe<TeamFilterInput>;
  homeTeamId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lobby?: InputMaybe<MatchLobbyFilterInput>;
  lobbyId?: InputMaybe<UuidOperationFilterInput>;
  matchType?: InputMaybe<MatchTypeOperationFilterInput>;
  maxGames?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<GameSeriesFilterInput>>;
  scheduledStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tier?: InputMaybe<TierFilterInput>;
  tierId?: InputMaybe<UuidOperationFilterInput>;
};

export type GameSeriesSortInput = {
  awayTeam?: InputMaybe<TeamSortInput>;
  awayTeamId?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  homeTeam?: InputMaybe<TeamSortInput>;
  homeTeamId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lobby?: InputMaybe<MatchLobbySortInput>;
  lobbyId?: InputMaybe<SortEnumType>;
  matchType?: InputMaybe<SortEnumType>;
  maxGames?: InputMaybe<SortEnumType>;
  scheduledStartTime?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tier?: InputMaybe<TierSortInput>;
  tierId?: InputMaybe<SortEnumType>;
};

export type GameServer = {
  __typename?: 'GameServer';
  connectString?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  ipAddress?: Maybe<Scalars['String']>;
  lastHeartbeat?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
  provider: ServerProvider;
  serverId: Scalars['String'];
  status: ServerStatus;
};

export type GameServerFilterInput = {
  and?: InputMaybe<Array<GameServerFilterInput>>;
  connectString?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  games?: InputMaybe<ListFilterInputTypeOfGameFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  ipAddress?: InputMaybe<StringOperationFilterInput>;
  lastHeartbeat?: InputMaybe<DateTimeOperationFilterInput>;
  lobbies?: InputMaybe<ListFilterInputTypeOfMatchLobbyFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GameServerFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  port?: InputMaybe<IntOperationFilterInput>;
  provider?: InputMaybe<ServerProviderOperationFilterInput>;
  serverId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ServerStatusOperationFilterInput>;
};

export type GameServerSortInput = {
  connectString?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ipAddress?: InputMaybe<SortEnumType>;
  lastHeartbeat?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  port?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<SortEnumType>;
  serverId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type GameSortInput = {
  awayTeamScore?: InputMaybe<SortEnumType>;
  demoUrl?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  gameSeries?: InputMaybe<GameSeriesSortInput>;
  gameSeriesId?: InputMaybe<SortEnumType>;
  homeTeamScore?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lobby?: InputMaybe<MatchLobbySortInput>;
  lobbyId?: InputMaybe<SortEnumType>;
  map?: InputMaybe<SortEnumType>;
  matchType?: InputMaybe<SortEnumType>;
  ratingsProcessed?: InputMaybe<SortEnumType>;
  scheduledTime?: InputMaybe<SortEnumType>;
  server?: InputMaybe<GameServerSortInput>;
  serverId?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tier?: InputMaybe<TierSortInput>;
  tierId?: InputMaybe<SortEnumType>;
  winningTeam?: InputMaybe<SortEnumType>;
};

export type IntOperationFilterInput = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type JoinCombineQueueResult = {
  __typename?: 'JoinCombineQueueResult';
  message: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  queueId?: Maybe<Scalars['UUID']>;
  success: Scalars['Boolean'];
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  linkedAccountTypeId?: Maybe<Scalars['UUID']>;
  owner: User;
  type?: Maybe<LinkedAccountType>;
  userId?: Maybe<Scalars['UUID']>;
};

export type LinkedAccountFilterInput = {
  accountId?: InputMaybe<StringOperationFilterInput>;
  accountName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LinkedAccountFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  linkedAccountTypeId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<LinkedAccountFilterInput>>;
  owner?: InputMaybe<UserFilterInput>;
  type?: InputMaybe<LinkedAccountTypeFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type LinkedAccountInput = {
  accountId?: InputMaybe<Scalars['String']>;
  accountName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  linkedAccountTypeId?: InputMaybe<Scalars['UUID']>;
  owner: UserInput;
  type: LinkedAccountTypeInput;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type LinkedAccountType = {
  __typename?: 'LinkedAccountType';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
};

export type LinkedAccountTypeFilterInput = {
  and?: InputMaybe<Array<LinkedAccountTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LinkedAccountTypeFilterInput>>;
  typeCode?: InputMaybe<StringOperationFilterInput>;
};

export type LinkedAccountTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  typeCode?: InputMaybe<Scalars['String']>;
};

/** A segment of a collection. */
export type ListAllSettingsCollectionSegment = {
  __typename?: 'ListAllSettingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Setting>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ListFilterInputTypeOfActionRoleAssignmentFilterInput = {
  all?: InputMaybe<ActionRoleAssignmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActionRoleAssignmentFilterInput>;
  some?: InputMaybe<ActionRoleAssignmentFilterInput>;
};

export type ListFilterInputTypeOfAdminMemoFilterInput = {
  all?: InputMaybe<AdminMemoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdminMemoFilterInput>;
  some?: InputMaybe<AdminMemoFilterInput>;
};

export type ListFilterInputTypeOfGameFilterInput = {
  all?: InputMaybe<GameFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<GameFilterInput>;
  some?: InputMaybe<GameFilterInput>;
};

export type ListFilterInputTypeOfGameSeriesFilterInput = {
  all?: InputMaybe<GameSeriesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<GameSeriesFilterInput>;
  some?: InputMaybe<GameSeriesFilterInput>;
};

export type ListFilterInputTypeOfLinkedAccountFilterInput = {
  all?: InputMaybe<LinkedAccountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LinkedAccountFilterInput>;
  some?: InputMaybe<LinkedAccountFilterInput>;
};

export type ListFilterInputTypeOfLobbyPlayerFilterInput = {
  all?: InputMaybe<LobbyPlayerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LobbyPlayerFilterInput>;
  some?: InputMaybe<LobbyPlayerFilterInput>;
};

export type ListFilterInputTypeOfMapBanFilterInput = {
  all?: InputMaybe<MapBanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MapBanFilterInput>;
  some?: InputMaybe<MapBanFilterInput>;
};

export type ListFilterInputTypeOfMatchLobbyFilterInput = {
  all?: InputMaybe<MatchLobbyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MatchLobbyFilterInput>;
  some?: InputMaybe<MatchLobbyFilterInput>;
};

export type ListFilterInputTypeOfPlayerMatchStatsFilterInput = {
  all?: InputMaybe<PlayerMatchStatsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PlayerMatchStatsFilterInput>;
  some?: InputMaybe<PlayerMatchStatsFilterInput>;
};

export type ListFilterInputTypeOfSeasonTierFilterInput = {
  all?: InputMaybe<SeasonTierFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SeasonTierFilterInput>;
  some?: InputMaybe<SeasonTierFilterInput>;
};

export type ListFilterInputTypeOfTransactionApprovalFilterInput = {
  all?: InputMaybe<TransactionApprovalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TransactionApprovalFilterInput>;
  some?: InputMaybe<TransactionApprovalFilterInput>;
};

export type ListFilterInputTypeOfTransactionItemFilterInput = {
  all?: InputMaybe<TransactionItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TransactionItemFilterInput>;
  some?: InputMaybe<TransactionItemFilterInput>;
};

export type ListFilterInputTypeOfUserFilterInput = {
  all?: InputMaybe<UserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserFilterInput>;
  some?: InputMaybe<UserFilterInput>;
};

export type ListFilterInputTypeOfUserRoleFilterInput = {
  all?: InputMaybe<UserRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserRoleFilterInput>;
  some?: InputMaybe<UserRoleFilterInput>;
};

/** A segment of a collection. */
export type ListGameSeriesCollectionSegment = {
  __typename?: 'ListGameSeriesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GameSeries>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ListGamesCollectionSegment = {
  __typename?: 'ListGamesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Game>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LobbyAction = {
  __typename?: 'LobbyAction';
  team?: Maybe<PlayerTeam>;
  timeoutAt: Scalars['DateTime'];
  type: LobbyActionType;
};

export enum LobbyActionType {
  Acknowledge = 'ACKNOWLEDGE',
  BanMap = 'BAN_MAP',
  ReadyUp = 'READY_UP',
  Wait = 'WAIT'
}

export type LobbyPlayer = {
  __typename?: 'LobbyPlayer';
  id: Scalars['UUID'];
  isConnected: Scalars['Boolean'];
  isReady: Scalars['Boolean'];
  joinedAt: Scalars['DateTime'];
  lobbyId: Scalars['UUID'];
  readiedAt?: Maybe<Scalars['DateTime']>;
  team: PlayerTeam;
  user: User;
  userId: Scalars['UUID'];
};

export type LobbyPlayerFilterInput = {
  and?: InputMaybe<Array<LobbyPlayerFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isConnected?: InputMaybe<BooleanOperationFilterInput>;
  isReady?: InputMaybe<BooleanOperationFilterInput>;
  joinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  lobby?: InputMaybe<MatchLobbyFilterInput>;
  lobbyId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<LobbyPlayerFilterInput>>;
  readiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  team?: InputMaybe<PlayerTeamOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export enum LobbyStatus {
  Abandoned = 'ABANDONED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  MapSelection = 'MAP_SELECTION',
  ProvisioningServer = 'PROVISIONING_SERVER',
  Ready = 'READY',
  WaitingForPlayers = 'WAITING_FOR_PLAYERS',
  WaitingForReady = 'WAITING_FOR_READY'
}

export type LobbyStatusOperationFilterInput = {
  equals?: InputMaybe<LobbyStatus>;
  in?: InputMaybe<Array<LobbyStatus>>;
  neq?: InputMaybe<LobbyStatus>;
  nin?: InputMaybe<Array<LobbyStatus>>;
};

export enum LobbyType {
  Combine = 'COMBINE',
  Custom = 'CUSTOM',
  Tournament = 'TOURNAMENT'
}

export type LobbyTypeOperationFilterInput = {
  equals?: InputMaybe<LobbyType>;
  in?: InputMaybe<Array<LobbyType>>;
  neq?: InputMaybe<LobbyType>;
  nin?: InputMaybe<Array<LobbyType>>;
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  isAuthenticated: Scalars['Boolean'];
  refreshToken?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type MapBan = {
  __typename?: 'MapBan';
  id: Scalars['UUID'];
  lobbyId: Scalars['UUID'];
  mapName: Scalars['String'];
  order: Scalars['Int'];
  team: PlayerTeam;
  timestamp: Scalars['DateTime'];
  type: MapBanType;
};

export type MapBanFilterInput = {
  and?: InputMaybe<Array<MapBanFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lobby?: InputMaybe<MatchLobbyFilterInput>;
  lobbyId?: InputMaybe<UuidOperationFilterInput>;
  mapName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MapBanFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  team?: InputMaybe<PlayerTeamOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  type?: InputMaybe<MapBanTypeOperationFilterInput>;
};

export enum MapBanType {
  Ban = 'BAN',
  Pick = 'PICK'
}

export type MapBanTypeOperationFilterInput = {
  equals?: InputMaybe<MapBanType>;
  in?: InputMaybe<Array<MapBanType>>;
  neq?: InputMaybe<MapBanType>;
  nin?: InputMaybe<Array<MapBanType>>;
};

export type MatchLobby = {
  __typename?: 'MatchLobby';
  createdAt: Scalars['DateTime'];
  currentAction?: Maybe<LobbyAction>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  gameSeries: Array<GameSeries>;
  games: Array<Game>;
  id: Scalars['UUID'];
  isProvisioningServer: Scalars['Boolean'];
  lobbyType: LobbyType;
  mapBans: Array<MapBan>;
  mapPool: Array<Scalars['String']>;
  players: Array<LobbyPlayer>;
  selectedMap?: Maybe<Scalars['String']>;
  server?: Maybe<GameServer>;
  serverId?: Maybe<Scalars['UUID']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: LobbyStatus;
  tier?: Maybe<Tier>;
  tierId?: Maybe<Scalars['UUID']>;
};

export type MatchLobbyFilterInput = {
  and?: InputMaybe<Array<MatchLobbyFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  gameSeries?: InputMaybe<ListFilterInputTypeOfGameSeriesFilterInput>;
  games?: InputMaybe<ListFilterInputTypeOfGameFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isProvisioningServer?: InputMaybe<BooleanOperationFilterInput>;
  lobbyType?: InputMaybe<LobbyTypeOperationFilterInput>;
  mapBans?: InputMaybe<ListFilterInputTypeOfMapBanFilterInput>;
  mapPool?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<MatchLobbyFilterInput>>;
  players?: InputMaybe<ListFilterInputTypeOfLobbyPlayerFilterInput>;
  selectedMap?: InputMaybe<StringOperationFilterInput>;
  server?: InputMaybe<GameServerFilterInput>;
  serverId?: InputMaybe<UuidOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<LobbyStatusOperationFilterInput>;
  tier?: InputMaybe<TierFilterInput>;
  tierId?: InputMaybe<UuidOperationFilterInput>;
};

export type MatchLobbySortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isProvisioningServer?: InputMaybe<SortEnumType>;
  lobbyType?: InputMaybe<SortEnumType>;
  selectedMap?: InputMaybe<SortEnumType>;
  server?: InputMaybe<GameServerSortInput>;
  serverId?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tier?: InputMaybe<TierSortInput>;
  tierId?: InputMaybe<SortEnumType>;
};

export enum MatchType {
  Combine = 'COMBINE',
  Custom = 'CUSTOM',
  FreeAgent = 'FREE_AGENT',
  Playoff = 'PLAYOFF',
  RegularSeason = 'REGULAR_SEASON',
  Scrim = 'SCRIM',
  Tournament = 'TOURNAMENT'
}

export type MatchTypeOperationFilterInput = {
  equals?: InputMaybe<MatchType>;
  in?: InputMaybe<Array<MatchType>>;
  neq?: InputMaybe<MatchType>;
  nin?: InputMaybe<Array<MatchType>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeCombineLobby: Scalars['Boolean'];
  activateSeason: Scalars['Boolean'];
  addPlayerToTeam: Team;
  addTeam: Team;
  addUserMemo: Scalars['Boolean'];
  adminRevokeUserSessions: Scalars['Int'];
  archiveSeason: Scalars['Boolean'];
  assignActionToRole: ActionAssignmentResult;
  assignRoleToUser: UserRoleAssignmentResult;
  authenticate?: Maybe<AuthenticatePayload>;
  banMap: BanMapResult;
  cancelCombineLobby: Scalars['Boolean'];
  concludeSeason: Scalars['Boolean'];
  createAuthAction: AuthActionMutationResult;
  createFranchise: Franchise;
  createRole: RoleMutationResult;
  createSeason: Season;
  createStaffPosition: StaffPosition;
  createTransaction: Transaction;
  deleteRole: RoleMutationResult;
  deleteTransaction: Transaction;
  deleteUser: Scalars['Boolean'];
  executeTransaction: Transaction;
  forceCombineMatchmaking?: Maybe<MatchLobby>;
  joinCombineQueue: JoinCombineQueueResult;
  leaveCombineQueue: Scalars['Boolean'];
  login: LoginPayload;
  publishSeason: Scalars['Boolean'];
  readyUpInLobby: Scalars['Boolean'];
  refresh: LoginPayload;
  removePlayerFromTeam: Team;
  revokeAllMySessions: Scalars['Int'];
  revokeRefreshToken: Scalars['Boolean'];
  setFranchiseAGM: UpdateFranchiseStaffPayload;
  setFranchiseGM: UpdateFranchiseStaffPayload;
  setTeamActive: Team;
  setTeamCaptain: Team;
  setTransactionApprovalStatus: TransactionApproval;
  setUserFlags: SetUserFlagsPayload;
  settings: SettingsMutations;
  signup: SignupPayload;
  syncDiscoveredActions: ActionSyncResult;
  testMute: Scalars['String'];
  unassignActionFromRole: ActionAssignmentResult;
  unassignRoleFromUser: UserRoleAssignmentResult;
  updateFranchise: Franchise;
  updateFranchiseStaff: UpdateFranchiseStaffPayload;
  updateRole: RoleMutationResult;
  updateSeason: Season;
  updateTeamName: Team;
  updateUser: User;
};


export type MutationAcknowledgeCombineLobbyArgs = {
  lobbyId: Scalars['UUID'];
};


export type MutationActivateSeasonArgs = {
  id: Scalars['UUID'];
};


export type MutationAddPlayerToTeamArgs = {
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationAddTeamArgs = {
  franchiseId: Scalars['UUID'];
  teamName: Scalars['String'];
};


export type MutationAddUserMemoArgs = {
  memo: Scalars['String'];
  userId: Scalars['UUID'];
};


export type MutationAdminRevokeUserSessionsArgs = {
  userId: Scalars['UUID'];
};


export type MutationArchiveSeasonArgs = {
  id: Scalars['UUID'];
};


export type MutationAssignActionToRoleArgs = {
  actionKey: Scalars['String'];
  roleId: Scalars['UUID'];
};


export type MutationAssignRoleToUserArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  roleId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['UUID'];
};


export type MutationAuthenticateArgs = {
  authCode: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationBanMapArgs = {
  lobbyId: Scalars['UUID'];
  mapName: Scalars['String'];
};


export type MutationCancelCombineLobbyArgs = {
  lobbyId: Scalars['UUID'];
};


export type MutationConcludeSeasonArgs = {
  id: Scalars['UUID'];
};


export type MutationCreateAuthActionArgs = {
  input: CreateAuthActionInput;
};


export type MutationCreateFranchiseArgs = {
  input: CreateFranchiseInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationCreateStaffPositionArgs = {
  input: CreateStaffPositionInput;
};


export type MutationCreateTransactionArgs = {
  input: CreateTransactionInput;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTransactionArgs = {
  transactionId: Scalars['UUID'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['UUID'];
};


export type MutationExecuteTransactionArgs = {
  transactionId: Scalars['UUID'];
};


export type MutationForceCombineMatchmakingArgs = {
  tierId: Scalars['UUID'];
};


export type MutationJoinCombineQueueArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type MutationLoginArgs = {
  discordAuthCode: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationPublishSeasonArgs = {
  id: Scalars['UUID'];
};


export type MutationReadyUpInLobbyArgs = {
  lobbyId: Scalars['UUID'];
};


export type MutationRefreshArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRemovePlayerFromTeamArgs = {
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationRevokeRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationSetFranchiseAgmArgs = {
  franchiseId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};


export type MutationSetFranchiseGmArgs = {
  franchiseId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};


export type MutationSetTeamActiveArgs = {
  active: Scalars['Boolean'];
  teamId: Scalars['UUID'];
};


export type MutationSetTeamCaptainArgs = {
  teamId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};


export type MutationSetTransactionApprovalStatusArgs = {
  input: SetTransactionApprovalInput;
};


export type MutationSetUserFlagsArgs = {
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isSuspended?: InputMaybe<Scalars['Boolean']>;
  isWatchlist?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['UUID'];
};


export type MutationSignupArgs = {
  discordAuthCode: Scalars['String'];
  redirectUri: Scalars['String'];
};


export type MutationSyncDiscoveredActionsArgs = {
  cleanupOrphaned?: Scalars['Boolean'];
};


export type MutationUnassignActionFromRoleArgs = {
  actionKey: Scalars['String'];
  roleId: Scalars['UUID'];
};


export type MutationUnassignRoleFromUserArgs = {
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationUpdateFranchiseArgs = {
  input: UpdateFranchiseInput;
};


export type MutationUpdateFranchiseStaffArgs = {
  franchiseId: Scalars['UUID'];
  input: UpdateFranchiseStaffInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['UUID'];
  input: UpdateRoleInput;
};


export type MutationUpdateSeasonArgs = {
  input: UpdateSeasonInput;
};


export type MutationUpdateTeamNameArgs = {
  teamId: Scalars['UUID'];
  teamName: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};

export type NullableOfPlayerTeamOperationFilterInput = {
  equals?: InputMaybe<PlayerTeam>;
  in?: InputMaybe<Array<InputMaybe<PlayerTeam>>>;
  neq?: InputMaybe<PlayerTeam>;
  nin?: InputMaybe<Array<InputMaybe<PlayerTeam>>>;
};

/** A segment of a collection. */
export type PendingFranchiseApprovalsCollectionSegment = {
  __typename?: 'PendingFranchiseApprovalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type PendingLeagueStaffApprovalsCollectionSegment = {
  __typename?: 'PendingLeagueStaffApprovalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type PendingTransactionsCollectionSegment = {
  __typename?: 'PendingTransactionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type PlayerMatchStats = {
  __typename?: 'PlayerMatchStats';
  assists: Scalars['Int'];
  averageDamagePerRound: Scalars['Float'];
  deaths: Scalars['Int'];
  fiveKills: Scalars['Int'];
  fourKills: Scalars['Int'];
  gameId: Scalars['UUID'];
  headshotKills: Scalars['Int'];
  id: Scalars['UUID'];
  kills: Scalars['Int'];
  mvps: Scalars['Int'];
  score: Scalars['Int'];
  team: PlayerTeam;
  threeKills: Scalars['Int'];
  user: User;
  userId: Scalars['UUID'];
};

export type PlayerMatchStatsFilterInput = {
  and?: InputMaybe<Array<PlayerMatchStatsFilterInput>>;
  assists?: InputMaybe<IntOperationFilterInput>;
  averageDamagePerRound?: InputMaybe<FloatOperationFilterInput>;
  deaths?: InputMaybe<IntOperationFilterInput>;
  fiveKills?: InputMaybe<IntOperationFilterInput>;
  fourKills?: InputMaybe<IntOperationFilterInput>;
  game?: InputMaybe<GameFilterInput>;
  gameId?: InputMaybe<UuidOperationFilterInput>;
  headshotKills?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  kills?: InputMaybe<IntOperationFilterInput>;
  mvps?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PlayerMatchStatsFilterInput>>;
  score?: InputMaybe<IntOperationFilterInput>;
  team?: InputMaybe<PlayerTeamOperationFilterInput>;
  threeKills?: InputMaybe<IntOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export enum PlayerTeam {
  TeamA = 'TEAM_A',
  TeamB = 'TEAM_B'
}

export type PlayerTeamOperationFilterInput = {
  equals?: InputMaybe<PlayerTeam>;
  in?: InputMaybe<Array<PlayerTeam>>;
  neq?: InputMaybe<PlayerTeam>;
  nin?: InputMaybe<Array<PlayerTeam>>;
};

export type Query = {
  __typename?: 'Query';
  actionCategories: Array<Scalars['String']>;
  activeCombineLobbies: Array<MatchLobby>;
  activeCombineMatches: Array<Game>;
  authAction?: Maybe<AuthAction>;
  authActions: Array<AuthAction>;
  authorizationAudits: Array<AuthorizationAudit>;
  combineMapPool: Array<Scalars['String']>;
  combineMatchHistory: Array<Game>;
  currentSeason?: Maybe<Season>;
  discoveredActions: Array<DiscoveredAction>;
  franchise?: Maybe<Franchise>;
  franchiseMatches: Array<Game>;
  franchises?: Maybe<FranchisesCollectionSegment>;
  game?: Maybe<Game>;
  gameSeries?: Maybe<GameSeries>;
  listAllSettings?: Maybe<ListAllSettingsCollectionSegment>;
  listGameSeries?: Maybe<ListGameSeriesCollectionSegment>;
  listGames?: Maybe<ListGamesCollectionSegment>;
  listSessions: Array<RefreshToken>;
  match?: Maybe<Game>;
  me: UserMePayload;
  myActions: Array<Scalars['String']>;
  myActiveCombineLobby?: Maybe<MatchLobby>;
  myCombineMatchHistory: Array<Game>;
  myCombineQueueStatus: CombineQueueStatus;
  orphanedActions: Array<AuthAction>;
  pendingFranchiseApprovals?: Maybe<PendingFranchiseApprovalsCollectionSegment>;
  pendingLeagueStaffApprovals?: Maybe<PendingLeagueStaffApprovalsCollectionSegment>;
  pendingTransactions?: Maybe<PendingTransactionsCollectionSegment>;
  publicSettings: Array<Setting>;
  role?: Maybe<Role>;
  roleUsers: Array<UserRole>;
  roles: Array<Role>;
  season?: Maybe<Season>;
  seasons?: Maybe<SeasonsCollectionSegment>;
  setting?: Maybe<Setting>;
  settings: Array<Setting>;
  settingsByPath: Array<Setting>;
  staffCategories: Array<Scalars['String']>;
  staffPosition?: Maybe<StaffPosition>;
  staffPositions: Array<StaffPosition>;
  team?: Maybe<Team>;
  teamMatches: Array<Game>;
  teams?: Maybe<TeamsCollectionSegment>;
  transaction?: Maybe<Transaction>;
  transactions?: Maybe<TransactionsCollectionSegment>;
  user?: Maybe<User>;
  userAdminMemos?: Maybe<UserAdminMemosCollectionSegment>;
  users?: Maybe<UsersCollectionSegment>;
};


export type QueryActiveCombineLobbiesArgs = {
  tierId?: InputMaybe<Scalars['UUID']>;
};


export type QueryActiveCombineMatchesArgs = {
  tierId?: InputMaybe<Scalars['UUID']>;
};


export type QueryAuthActionArgs = {
  key: Scalars['String'];
};


export type QueryAuthActionsArgs = {
  category?: InputMaybe<Scalars['String']>;
};


export type QueryAuthorizationAuditsArgs = {
  entity?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['UUID']>;
  first?: Scalars['Int'];
  offset?: Scalars['Int'];
};


export type QueryCombineMapPoolArgs = {
  tierId: Scalars['UUID'];
};


export type QueryCombineMatchHistoryArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  userId: Scalars['UUID'];
};


export type QueryFranchiseArgs = {
  id: Scalars['UUID'];
};


export type QueryFranchiseMatchesArgs = {
  franchiseId: Scalars['UUID'];
  limit?: Scalars['Int'];
  matchType?: InputMaybe<MatchType>;
  offset?: Scalars['Int'];
};


export type QueryFranchisesArgs = {
  order?: InputMaybe<Array<FranchiseSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FranchiseFilterInput>;
};


export type QueryGameArgs = {
  id: Scalars['UUID'];
};


export type QueryGameSeriesArgs = {
  id: Scalars['UUID'];
};


export type QueryListAllSettingsArgs = {
  order?: InputMaybe<Array<SettingSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SettingFilterInput>;
};


export type QueryListGameSeriesArgs = {
  order?: InputMaybe<Array<GameSeriesSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameSeriesFilterInput>;
};


export type QueryListGamesArgs = {
  order?: InputMaybe<Array<GameSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameFilterInput>;
};


export type QueryListSessionsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMatchArgs = {
  id: Scalars['UUID'];
};


export type QueryMyCombineMatchHistoryArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


export type QueryPendingFranchiseApprovalsArgs = {
  franchiseId: Scalars['UUID'];
  order?: InputMaybe<Array<TransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryPendingLeagueStaffApprovalsArgs = {
  order?: InputMaybe<Array<TransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryPendingTransactionsArgs = {
  franchiseId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Array<TransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryRoleArgs = {
  id: Scalars['UUID'];
};


export type QueryRoleUsersArgs = {
  includeExpired?: Scalars['Boolean'];
  roleId: Scalars['UUID'];
};


export type QueryRolesArgs = {
  nameFilter?: InputMaybe<Scalars['String']>;
};


export type QuerySeasonArgs = {
  id: Scalars['UUID'];
};


export type QuerySeasonsArgs = {
  order?: InputMaybe<Array<SeasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SeasonStatus>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeasonFilterInput>;
};


export type QuerySettingArgs = {
  path: Scalars['String'];
};


export type QuerySettingsArgs = {
  paths: Array<Scalars['String']>;
};


export type QuerySettingsByPathArgs = {
  depth?: InputMaybe<Scalars['Int']>;
  pathPrefix: Scalars['String'];
};


export type QueryStaffPositionArgs = {
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  positionCode?: InputMaybe<Scalars['String']>;
};


export type QueryStaffPositionsArgs = {
  category?: InputMaybe<Scalars['String']>;
};


export type QueryTeamArgs = {
  id: Scalars['UUID'];
};


export type QueryTeamMatchesArgs = {
  limit?: Scalars['Int'];
  matchType?: InputMaybe<MatchType>;
  offset?: Scalars['Int'];
  teamId: Scalars['UUID'];
};


export type QueryTeamsArgs = {
  order?: InputMaybe<Array<TeamSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeamFilterInput>;
};


export type QueryTransactionArgs = {
  id: Scalars['UUID'];
};


export type QueryTransactionsArgs = {
  franchiseId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Array<TransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
};


export type QueryUserArgs = {
  id: Scalars['UUID'];
};


export type QueryUserAdminMemosArgs = {
  order?: InputMaybe<Array<AdminMemoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['UUID'];
  where?: InputMaybe<AdminMemoFilterInput>;
};


export type QueryUsersArgs = {
  order?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
};

export enum QueueStatus {
  Cancelled = 'CANCELLED',
  Matched = 'MATCHED',
  Queued = 'QUEUED',
  TimedOut = 'TIMED_OUT'
}

export type RefreshToken = {
  __typename?: 'RefreshToken';
  createdAt: Scalars['DateTime'];
  deviceId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastAccessedAt: Scalars['DateTime'];
  replacedById?: Maybe<Scalars['Long']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  seqId: Scalars['Long'];
  sessionDetails?: Maybe<SessionDetails>;
  token: Scalars['String'];
  ttlMinutes: Scalars['Int'];
  userId: Scalars['UUID'];
};

export type Role = {
  __typename?: 'Role';
  actions: Array<ActionRoleAssignment>;
  color: Scalars['String'];
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['UUID'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RoleFilterInput = {
  actions?: InputMaybe<ListFilterInputTypeOfActionRoleAssignmentFilterInput>;
  and?: InputMaybe<Array<RoleFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  iconUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
};

export type RoleInput = {
  actions: Array<ActionRoleAssignmentInput>;
  color: Scalars['String'];
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['UUID'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RoleMutationResult = {
  __typename?: 'RoleMutationResult';
  errorMessage?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  success: Scalars['Boolean'];
};

export type Season = {
  __typename?: 'Season';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  endsAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  seasonNumber: Scalars['Int'];
  seasonTiers: Array<SeasonTier>;
  slug?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  status: SeasonStatus;
  tag: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
  visibleFrom?: Maybe<Scalars['DateTime']>;
  visibleTo?: Maybe<Scalars['DateTime']>;
};

export type SeasonFilterInput = {
  and?: InputMaybe<Array<SeasonFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  endsAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SeasonFilterInput>>;
  seasonNumber?: InputMaybe<IntOperationFilterInput>;
  seasonTiers?: InputMaybe<ListFilterInputTypeOfSeasonTierFilterInput>;
  slug?: InputMaybe<StringOperationFilterInput>;
  startsAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<SeasonStatusOperationFilterInput>;
  tag?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
  visibleFrom?: InputMaybe<DateTimeOperationFilterInput>;
  visibleTo?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SeasonSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  endsAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  seasonNumber?: InputMaybe<SortEnumType>;
  slug?: InputMaybe<SortEnumType>;
  startsAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
  visibleFrom?: InputMaybe<SortEnumType>;
  visibleTo?: InputMaybe<SortEnumType>;
};

export enum SeasonStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Concluded = 'CONCLUDED',
  Draft = 'DRAFT',
  Scheduled = 'SCHEDULED'
}

export type SeasonStatusOperationFilterInput = {
  equals?: InputMaybe<SeasonStatus>;
  in?: InputMaybe<Array<SeasonStatus>>;
  neq?: InputMaybe<SeasonStatus>;
  nin?: InputMaybe<Array<SeasonStatus>>;
};

export type SeasonTier = {
  __typename?: 'SeasonTier';
  id: Scalars['UUID'];
  mmrCap: Scalars['Int'];
  mmrMax: Scalars['Int'];
  mmrMin: Scalars['Int'];
  season: Season;
  seasonId: Scalars['UUID'];
  tier: Tier;
  tierId: Scalars['UUID'];
};

export type SeasonTierFilterInput = {
  and?: InputMaybe<Array<SeasonTierFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  mmrCap?: InputMaybe<IntOperationFilterInput>;
  mmrMax?: InputMaybe<IntOperationFilterInput>;
  mmrMin?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SeasonTierFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<UuidOperationFilterInput>;
  tier?: InputMaybe<TierFilterInput>;
  tierId?: InputMaybe<UuidOperationFilterInput>;
};

/** A segment of a collection. */
export type SeasonsCollectionSegment = {
  __typename?: 'SeasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Season>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum ServerProvider {
  CustomManaged = 'CUSTOM_MANAGED',
  DatHost = 'DAT_HOST'
}

export type ServerProviderOperationFilterInput = {
  equals?: InputMaybe<ServerProvider>;
  in?: InputMaybe<Array<ServerProvider>>;
  neq?: InputMaybe<ServerProvider>;
  nin?: InputMaybe<Array<ServerProvider>>;
};

export enum ServerStatus {
  Deleted = 'DELETED',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Provisioning = 'PROVISIONING'
}

export type ServerStatusOperationFilterInput = {
  equals?: InputMaybe<ServerStatus>;
  in?: InputMaybe<Array<ServerStatus>>;
  neq?: InputMaybe<ServerStatus>;
  nin?: InputMaybe<Array<ServerStatus>>;
};

export type SessionDetails = {
  __typename?: 'SessionDetails';
  ipAddress?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type SetTransactionApprovalInput = {
  approvalStatus: ApprovalStatus;
  id: Scalars['UUID'];
  notes?: InputMaybe<Scalars['String']>;
};

export type SetUserFlagsPayload = {
  __typename?: 'SetUserFlagsPayload';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** A path-based application setting */
export type Setting = {
  __typename?: 'Setting';
  createdAt: Scalars['DateTime'];
  /** How to interpret the Value field */
  dataType: SettingDataType;
  /** Human-readable description */
  description?: Maybe<Scalars['String']>;
  /** Last modification timestamp */
  modifiedAt: Scalars['DateTime'];
  /** Hierarchical path (e.g., /queues/ranked/enabled) */
  path: Scalars['String'];
  /** Setting value (always string, interpret based on DataType) */
  value: Scalars['String'];
  /** Access control level */
  visibility: SettingVisibility;
};

export enum SettingDataType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  Decimal = 'DECIMAL',
  Integer = 'INTEGER',
  Json = 'JSON',
  String = 'STRING',
  StringList = 'STRING_LIST'
}

export type SettingDataTypeOperationFilterInput = {
  equals?: InputMaybe<SettingDataType>;
  in?: InputMaybe<Array<SettingDataType>>;
  neq?: InputMaybe<SettingDataType>;
  nin?: InputMaybe<Array<SettingDataType>>;
};

export type SettingFilterInput = {
  and?: InputMaybe<Array<SettingFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dataType?: InputMaybe<SettingDataTypeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  modifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SettingFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
  visibility?: InputMaybe<SettingVisibilityOperationFilterInput>;
};

export type SettingSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  dataType?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  modifiedAt?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
  visibility?: InputMaybe<SortEnumType>;
};

export enum SettingVisibility {
  Internal = 'INTERNAL',
  Protected = 'PROTECTED',
  Public = 'PUBLIC',
  System = 'SYSTEM'
}

export type SettingVisibilityOperationFilterInput = {
  equals?: InputMaybe<SettingVisibility>;
  in?: InputMaybe<Array<SettingVisibility>>;
  neq?: InputMaybe<SettingVisibility>;
  nin?: InputMaybe<Array<SettingVisibility>>;
};

export type SettingsMutations = {
  __typename?: 'SettingsMutations';
  bulkUpsertSettings: Array<Setting>;
  deleteSetting: Scalars['Boolean'];
  upsertSetting: Setting;
};


export type SettingsMutationsBulkUpsertSettingsArgs = {
  settings: Array<UpsertSettingInput>;
};


export type SettingsMutationsDeleteSettingArgs = {
  path: Scalars['String'];
};


export type SettingsMutationsUpsertSettingArgs = {
  input: UpsertSettingInput;
};

export type SignupPayload = {
  __typename?: 'SignupPayload';
  outcome: SignupPayloadOutcome;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum SignupPayloadOutcome {
  AlreadyExists = 'ALREADY_EXISTS',
  Failed = 'FAILED',
  InvalidAuthentication = 'INVALID_AUTHENTICATION',
  Successful = 'SUCCESSFUL'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StaffPosition = {
  __typename?: 'StaffPosition';
  additionalData?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  positionCategory: Scalars['String'];
  positionCode: Scalars['String'];
  priority: Scalars['Int'];
};

export type StaffUser = {
  __typename?: 'StaffUser';
  position: StaffPosition;
  user: User;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  lobbyUpdated: MatchLobby;
  matchUpdated: Game;
  queueStatusUpdated: CombineQueueStatus;
};


export type SubscriptionLobbyUpdatedArgs = {
  lobbyId: Scalars['UUID'];
};


export type SubscriptionMatchUpdatedArgs = {
  matchId: Scalars['UUID'];
};

export type Team = {
  __typename?: 'Team';
  active: Scalars['Boolean'];
  franchise?: Maybe<Franchise>;
  franchiseId: Scalars['UUID'];
  id?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  players: Array<User>;
  tier?: Maybe<Scalars['String']>;
};

export type TeamFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TeamFilterInput>>;
  franchise?: InputMaybe<FranchiseFilterInput>;
  franchiseId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TeamFilterInput>>;
  players?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  tier?: InputMaybe<StringOperationFilterInput>;
};

export type TeamInput = {
  active: Scalars['Boolean'];
  franchise: FranchiseInput;
  franchiseId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  players: Array<UserInput>;
  tier?: InputMaybe<Scalars['String']>;
};

export type TeamSortInput = {
  active?: InputMaybe<SortEnumType>;
  franchise?: InputMaybe<FranchiseSortInput>;
  franchiseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tier?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type TeamsCollectionSegment = {
  __typename?: 'TeamsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Team>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Tier = {
  __typename?: 'Tier';
  id: Scalars['UUID'];
  seasonTiers: Array<SeasonTier>;
  tierName: Scalars['String'];
};

export type TierFilterInput = {
  and?: InputMaybe<Array<TierFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<TierFilterInput>>;
  seasonTiers?: InputMaybe<ListFilterInputTypeOfSeasonTierFilterInput>;
  tierName?: InputMaybe<StringOperationFilterInput>;
};

export type TierSortInput = {
  id?: InputMaybe<SortEnumType>;
  tierName?: InputMaybe<SortEnumType>;
};

export type Transaction = {
  __typename?: 'Transaction';
  dateExecuted?: Maybe<Scalars['DateTime']>;
  dateSubmitted: Scalars['DateTime'];
  id: Scalars['UUID'];
  notes?: Maybe<Scalars['String']>;
  submitter: User;
  submitterId: Scalars['UUID'];
  submittingFranchise?: Maybe<Franchise>;
  submittingFranchiseId?: Maybe<Scalars['UUID']>;
  tradePartnerFranchise?: Maybe<Franchise>;
  tradePartnerFranchiseId?: Maybe<Scalars['UUID']>;
  transactionApprovals: Array<TransactionApproval>;
  transactionItems: Array<TransactionItem>;
  transactionType: TransactionType;
};

export type TransactionApproval = {
  __typename?: 'TransactionApproval';
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvalStatus: ApprovalStatus;
  approver?: Maybe<User>;
  approverId?: Maybe<Scalars['UUID']>;
  approvingFranchise?: Maybe<Franchise>;
  approvingFranchiseId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isFranchiseStaffApproval: Scalars['Boolean'];
  isLeagueStaffApproval: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  transaction: Transaction;
  transactionId: Scalars['UUID'];
};

export type TransactionApprovalFilterInput = {
  and?: InputMaybe<Array<TransactionApprovalFilterInput>>;
  approvalDate?: InputMaybe<DateTimeOperationFilterInput>;
  approvalStatus?: InputMaybe<ApprovalStatusOperationFilterInput>;
  approver?: InputMaybe<UserFilterInput>;
  approverId?: InputMaybe<UuidOperationFilterInput>;
  approvingFranchise?: InputMaybe<FranchiseFilterInput>;
  approvingFranchiseId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isFranchiseStaffApproval?: InputMaybe<BooleanOperationFilterInput>;
  isLeagueStaffApproval?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransactionApprovalFilterInput>>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
};

export type TransactionFilterInput = {
  and?: InputMaybe<Array<TransactionFilterInput>>;
  dateExecuted?: InputMaybe<DateTimeOperationFilterInput>;
  dateSubmitted?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransactionFilterInput>>;
  submitter?: InputMaybe<UserFilterInput>;
  submitterId?: InputMaybe<UuidOperationFilterInput>;
  submittingFranchise?: InputMaybe<FranchiseFilterInput>;
  submittingFranchiseId?: InputMaybe<UuidOperationFilterInput>;
  tradePartnerFranchise?: InputMaybe<FranchiseFilterInput>;
  tradePartnerFranchiseId?: InputMaybe<UuidOperationFilterInput>;
  transactionApprovals?: InputMaybe<ListFilterInputTypeOfTransactionApprovalFilterInput>;
  transactionItems?: InputMaybe<ListFilterInputTypeOfTransactionItemFilterInput>;
  transactionType?: InputMaybe<TransactionTypeOperationFilterInput>;
};

export type TransactionItem = {
  __typename?: 'TransactionItem';
  id: Scalars['UUID'];
  itemOwner?: Maybe<Team>;
  itemOwnerId?: Maybe<Scalars['UUID']>;
  itemReceiver?: Maybe<Team>;
  itemReceiverId?: Maybe<Scalars['UUID']>;
  player?: Maybe<User>;
  playerId?: Maybe<Scalars['UUID']>;
  transaction: Transaction;
  transactionId: Scalars['UUID'];
};

export type TransactionItemFilterInput = {
  and?: InputMaybe<Array<TransactionItemFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  itemOwner?: InputMaybe<TeamFilterInput>;
  itemOwnerId?: InputMaybe<UuidOperationFilterInput>;
  itemReceiver?: InputMaybe<TeamFilterInput>;
  itemReceiverId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<TransactionItemFilterInput>>;
  player?: InputMaybe<UserFilterInput>;
  playerId?: InputMaybe<UuidOperationFilterInput>;
  transaction?: InputMaybe<TransactionFilterInput>;
  transactionId?: InputMaybe<UuidOperationFilterInput>;
};

export type TransactionItemInput = {
  itemOwnerId?: InputMaybe<Scalars['UUID']>;
  itemReceiverId?: InputMaybe<Scalars['UUID']>;
  playerId?: InputMaybe<Scalars['UUID']>;
};

export type TransactionSortInput = {
  dateExecuted?: InputMaybe<SortEnumType>;
  dateSubmitted?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  submitter?: InputMaybe<UserSortInput>;
  submitterId?: InputMaybe<SortEnumType>;
  submittingFranchise?: InputMaybe<FranchiseSortInput>;
  submittingFranchiseId?: InputMaybe<SortEnumType>;
  tradePartnerFranchise?: InputMaybe<FranchiseSortInput>;
  tradePartnerFranchiseId?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
};

export enum TransactionType {
  Captain = 'CAPTAIN',
  Cut = 'CUT',
  Ir = 'IR',
  Promote = 'PROMOTE',
  Relegate = 'RELEGATE',
  Reschedule = 'RESCHEDULE',
  Resign = 'RESIGN',
  Sign = 'SIGN',
  Sub = 'SUB',
  Trade = 'TRADE'
}

export type TransactionTypeOperationFilterInput = {
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  neq?: InputMaybe<TransactionType>;
  nin?: InputMaybe<Array<TransactionType>>;
};

/** A segment of a collection. */
export type TransactionsCollectionSegment = {
  __typename?: 'TransactionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Transaction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UpdateFranchiseInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  franchiseId: Scalars['UUID'];
  logoUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type UpdateFranchiseStaffInput = {
  operation: Scalars['String'];
  staffCode?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

export type UpdateFranchiseStaffPayload = {
  __typename?: 'UpdateFranchiseStaffPayload';
  successful: Scalars['Boolean'];
};

export type UpdateRoleInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSeasonInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  seasonId: Scalars['UUID'];
  startsAt?: InputMaybe<Scalars['DateTime']>;
  tag?: InputMaybe<Scalars['String']>;
  visibleFrom?: InputMaybe<Scalars['DateTime']>;
  visibleTo?: InputMaybe<Scalars['DateTime']>;
};

export type UpsertSettingInput = {
  dataType: SettingDataType;
  description?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  value: Scalars['String'];
  visibility: SettingVisibility;
};

export type User = {
  __typename?: 'User';
  adminMemos?: Maybe<Array<Maybe<AdminMemo>>>;
  assignedRoles?: Maybe<Array<Maybe<Role>>>;
  avatarUrl?: Maybe<Scalars['String']>;
  currentTeam?: Maybe<Team>;
  currentTeamId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isBanned: Scalars['Boolean'];
  isCaptain: Scalars['Boolean'];
  isOnIr: Scalars['Boolean'];
  isSuspended: Scalars['Boolean'];
  isWatchlist: Scalars['Boolean'];
  linkedAccounts?: Maybe<Array<Maybe<LinkedAccount>>>;
  mmr?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  roleNames?: Maybe<Array<Scalars['String']>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A segment of a collection. */
export type UserAdminMemosCollectionSegment = {
  __typename?: 'UserAdminMemosCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminMemo>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UserFilterInput = {
  adminMemos?: InputMaybe<ListFilterInputTypeOfAdminMemoFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  avatarUrl?: InputMaybe<StringOperationFilterInput>;
  currentTeam?: InputMaybe<TeamFilterInput>;
  currentTeamId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isBanned?: InputMaybe<BooleanOperationFilterInput>;
  isCaptain?: InputMaybe<BooleanOperationFilterInput>;
  isOnIr?: InputMaybe<BooleanOperationFilterInput>;
  isSuspended?: InputMaybe<BooleanOperationFilterInput>;
  isWatchlist?: InputMaybe<BooleanOperationFilterInput>;
  linkedAccounts?: InputMaybe<ListFilterInputTypeOfLinkedAccountFilterInput>;
  mmr?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  roleNames?: InputMaybe<ListStringOperationFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfUserRoleFilterInput>;
};

export type UserInput = {
  adminMemos: Array<AdminMemoInput>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  currentTeam?: InputMaybe<TeamInput>;
  currentTeamId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isBanned: Scalars['Boolean'];
  isCaptain: Scalars['Boolean'];
  isOnIr: Scalars['Boolean'];
  isSuspended: Scalars['Boolean'];
  isWatchlist: Scalars['Boolean'];
  linkedAccounts: Array<LinkedAccountInput>;
  name: Scalars['String'];
  roles: Array<UserRoleInput>;
};

export type UserMePayload = {
  __typename?: 'UserMePayload';
  userData: User;
};

export type UserRole = {
  __typename?: 'UserRole';
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
  startDate: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

export type UserRoleAssignmentResult = {
  __typename?: 'UserRoleAssignmentResult';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userRole?: Maybe<UserRole>;
};

export type UserRoleFilterInput = {
  and?: InputMaybe<Array<UserRoleFilterInput>>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserRoleFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<UuidOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserRoleInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  role?: InputMaybe<RoleInput>;
  roleId: Scalars['UUID'];
  startDate: Scalars['DateTime'];
  user?: InputMaybe<UserInput>;
  userId: Scalars['UUID'];
};

export type UserSortInput = {
  avatarUrl?: InputMaybe<SortEnumType>;
  currentTeam?: InputMaybe<TeamSortInput>;
  currentTeamId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBanned?: InputMaybe<SortEnumType>;
  isCaptain?: InputMaybe<SortEnumType>;
  isOnIr?: InputMaybe<SortEnumType>;
  isSuspended?: InputMaybe<SortEnumType>;
  isWatchlist?: InputMaybe<SortEnumType>;
  mmr?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UsersCollectionSegment = {
  __typename?: 'UsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UuidOperationFilterInput = {
  equals?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type GetMyActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyActionsQuery = { __typename?: 'Query', myActions: Array<string> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean }> };

export type AssignRoleToUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type AssignRoleToUserMutation = { __typename?: 'Mutation', assignRoleToUser: { __typename?: 'UserRoleAssignmentResult', success: boolean, errorMessage?: string | null, userRole?: { __typename?: 'UserRole', id: any, userId: any, roleId: any, startDate: any, endDate?: any | null } | null } };

export type UnassignRoleFromUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type UnassignRoleFromUserMutation = { __typename?: 'Mutation', unassignRoleFromUser: { __typename?: 'UserRoleAssignmentResult', success: boolean, errorMessage?: string | null } };

export type MyCombineQueueStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCombineQueueStatusQuery = { __typename?: 'Query', myCombineQueueStatus: { __typename?: 'CombineQueueStatus', isQueued: boolean, position?: number | null, estimatedWaitTime?: number | null, queuedAt?: any | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null } };

export type MyActiveCombineLobbyQueryVariables = Exact<{ [key: string]: never; }>;


export type MyActiveCombineLobbyQuery = { __typename?: 'Query', myActiveCombineLobby?: { __typename?: 'MatchLobby', id: any, lobbyType: LobbyType, status: LobbyStatus, createdAt: any, expiresAt?: any | null, selectedMap?: string | null, mapPool: Array<string>, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, players: Array<{ __typename?: 'LobbyPlayer', id: any, team: PlayerTeam, isReady: boolean, isConnected: boolean, joinedAt: any, user: { __typename?: 'User', id: any, name: string } }>, mapBans: Array<{ __typename?: 'MapBan', id: any, team: PlayerTeam, type: MapBanType, mapName: string, order: number, timestamp: any }>, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null, password?: string | null, status: ServerStatus } | null, currentAction?: { __typename?: 'LobbyAction', type: LobbyActionType, team?: PlayerTeam | null, timeoutAt: any } | null } | null };

export type ActiveCombineMatchesQueryVariables = Exact<{
  tierId?: InputMaybe<Scalars['UUID']>;
}>;


export type ActiveCombineMatchesQuery = { __typename?: 'Query', activeCombineMatches: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null } | null }> };

export type MyCombineMatchHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type MyCombineMatchHistoryQuery = { __typename?: 'Query', myCombineMatchHistory: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null }> };

export type MatchQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MatchQuery = { __typename?: 'Query', match?: { __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, ratingsProcessed: boolean, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null, password?: string | null } | null, lobby?: { __typename?: 'MatchLobby', id: any, status: LobbyStatus, players: Array<{ __typename?: 'LobbyPlayer', id: any, team: PlayerTeam, user: { __typename?: 'User', id: any, name: string } }> } | null, playerStats?: Array<{ __typename?: 'PlayerMatchStats', id: any, userId: any, team: PlayerTeam, kills: number, deaths: number, assists: number, score: number, mvps: number, headshotKills: number, averageDamagePerRound: number, threeKills: number, fourKills: number, fiveKills: number, user: { __typename?: 'User', id: any, name: string } } | null> | null } | null };

export type TeamMatchesQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  matchType?: InputMaybe<MatchType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type TeamMatchesQuery = { __typename?: 'Query', teamMatches: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, gameSeries?: { __typename?: 'GameSeries', id: any, homeTeamId?: any | null, awayTeamId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string } | null } | null }> };

export type FranchiseMatchesQueryVariables = Exact<{
  franchiseId: Scalars['UUID'];
  matchType?: InputMaybe<MatchType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FranchiseMatchesQuery = { __typename?: 'Query', franchiseMatches: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, gameSeries?: { __typename?: 'GameSeries', id: any, homeTeamId?: any | null, awayTeamId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string } | null } | null }> };

export type CombineMapPoolQueryVariables = Exact<{
  tierId: Scalars['UUID'];
}>;


export type CombineMapPoolQuery = { __typename?: 'Query', combineMapPool: Array<string> };

export type JoinCombineQueueMutationVariables = Exact<{ [key: string]: never; }>;


export type JoinCombineQueueMutation = { __typename?: 'Mutation', joinCombineQueue: { __typename?: 'JoinCombineQueueResult', success: boolean, queueId?: any | null, position?: number | null, message: string } };

export type LeaveCombineQueueMutationVariables = Exact<{ [key: string]: never; }>;


export type LeaveCombineQueueMutation = { __typename?: 'Mutation', leaveCombineQueue: boolean };

export type AcknowledgeCombineLobbyMutationVariables = Exact<{
  lobbyId: Scalars['UUID'];
}>;


export type AcknowledgeCombineLobbyMutation = { __typename?: 'Mutation', acknowledgeCombineLobby: boolean };

export type ReadyUpInLobbyMutationVariables = Exact<{
  lobbyId: Scalars['UUID'];
}>;


export type ReadyUpInLobbyMutation = { __typename?: 'Mutation', readyUpInLobby: boolean };

export type BanMapMutationVariables = Exact<{
  lobbyId: Scalars['UUID'];
  mapName: Scalars['String'];
}>;


export type BanMapMutation = { __typename?: 'Mutation', banMap: { __typename?: 'BanMapResult', success: boolean, message: string } };

export type CombineQueueUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CombineQueueUpdatedSubscription = { __typename?: 'Subscription', queueStatusUpdated: { __typename?: 'CombineQueueStatus', isQueued: boolean, position?: number | null, estimatedWaitTime?: number | null, queuedAt?: any | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null } };

export type CombineLobbyUpdatedSubscriptionVariables = Exact<{
  lobbyId: Scalars['UUID'];
}>;


export type CombineLobbyUpdatedSubscription = { __typename?: 'Subscription', lobbyUpdated: { __typename?: 'MatchLobby', id: any, lobbyType: LobbyType, status: LobbyStatus, createdAt: any, expiresAt?: any | null, selectedMap?: string | null, mapPool: Array<string>, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, players: Array<{ __typename?: 'LobbyPlayer', id: any, team: PlayerTeam, isReady: boolean, isConnected: boolean, joinedAt: any, user: { __typename?: 'User', id: any, name: string } }>, mapBans: Array<{ __typename?: 'MapBan', id: any, team: PlayerTeam, type: MapBanType, mapName: string, order: number, timestamp: any }>, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null, password?: string | null, status: ServerStatus } | null, currentAction?: { __typename?: 'LobbyAction', type: LobbyActionType, team?: PlayerTeam | null, timeoutAt: any } | null } };

export type CombineMatchUpdatedSubscriptionVariables = Exact<{
  matchId: Scalars['UUID'];
}>;


export type CombineMatchUpdatedSubscription = { __typename?: 'Subscription', matchUpdated: { __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null } | null, playerStats?: Array<{ __typename?: 'PlayerMatchStats', id: any, userId: any, team: PlayerTeam, kills: number, deaths: number, assists: number, score: number, user: { __typename?: 'User', id: any, name: string } } | null> | null } };

export type ListFranchisesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FranchiseFilterInput>;
  order?: InputMaybe<Array<FranchiseSortInput> | FranchiseSortInput>;
}>;


export type ListFranchisesQuery = { __typename?: 'Query', franchises?: { __typename?: 'FranchisesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Franchise', id: any, name: string, active: boolean, logoUrl?: string | null, prefix?: string | null, GM?: { __typename?: 'User', id: any, name: string } | null, AGM?: { __typename?: 'User', id: any, name: string } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CreateFranchiseMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateFranchiseMutation = { __typename?: 'Mutation', createFranchise: { __typename?: 'Franchise', name: string, id: any } };

export type FranchiseDetailsQueryVariables = Exact<{
  franchiseId: Scalars['UUID'];
}>;


export type FranchiseDetailsQuery = { __typename?: 'Query', franchise?: { __typename?: 'Franchise', name: string, id: any, active: boolean, prefix?: string | null, logoUrl?: string | null, GM?: { __typename?: 'User', name: string, id: any } | null, GMStaffPosition?: { __typename?: 'StaffPosition', id: any, positionCode: string, positionCategory: string, priority: number } | null, AGM?: { __typename?: 'User', name: string, id: any } | null, AGMStaffPosition?: { __typename?: 'StaffPosition', id: any, positionCode: string, positionCategory: string, priority: number } | null } | null };

export type FranchiseTeamsQueryVariables = Exact<{
  franchiseId: Scalars['UUID'];
}>;


export type FranchiseTeamsQuery = { __typename?: 'Query', teams?: { __typename?: 'TeamsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Team', id?: any | null, name: string, tier?: string | null, active: boolean, players: Array<{ __typename?: 'User', id: any, name: string }> }> | null } | null };

export type UpdateFranchiseMutationVariables = Exact<{
  franchiseId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateFranchiseMutation = { __typename?: 'Mutation', updateFranchise: { __typename?: 'Franchise', name: string, id: any } };

export type SetFranchiseGmMutationVariables = Exact<{
  franchiseId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type SetFranchiseGmMutation = { __typename?: 'Mutation', setFranchiseGM: { __typename?: 'UpdateFranchiseStaffPayload', successful: boolean } };

export type SetFranchiseAgmMutationVariables = Exact<{
  franchiseId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type SetFranchiseAgmMutation = { __typename?: 'Mutation', setFranchiseAGM: { __typename?: 'UpdateFranchiseStaffPayload', successful: boolean } };

export type UpdateFranchiseStaffMutationVariables = Exact<{
  franchiseId: Scalars['UUID'];
  operation: Scalars['String'];
  staffId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type UpdateFranchiseStaffMutation = { __typename?: 'Mutation', updateFranchiseStaff: { __typename?: 'UpdateFranchiseStaffPayload', successful: boolean } };

export type AllActiveFranchisesWithStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type AllActiveFranchisesWithStaffQuery = { __typename?: 'Query', franchises?: { __typename?: 'FranchisesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null, active: boolean, GM?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null } | null, AGM?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null } | null }> | null } | null };

export type GetMatchHistoryQueryVariables = Exact<{
  where?: InputMaybe<GameSeriesFilterInput>;
  order?: InputMaybe<Array<GameSeriesSortInput> | GameSeriesSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetMatchHistoryQuery = { __typename?: 'Query', listGameSeries?: { __typename?: 'ListGameSeriesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'GameSeries', id: any, matchType: MatchType, status?: string | null, maxGames: number, scheduledStartTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamId?: any | null, awayTeamId?: any | null, tierId?: any | null, lobbyId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string } | null } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string } | null } | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, games?: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null } | null> | null }> | null } | null };

export type ListGamesQueryVariables = Exact<{
  where?: InputMaybe<GameFilterInput>;
  order?: InputMaybe<Array<GameSortInput> | GameSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ListGamesQuery = { __typename?: 'Query', listGames?: { __typename?: 'ListGamesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, ratingsProcessed: boolean, tierId?: any | null, lobbyId?: any | null, gameSeriesId?: any | null, serverId?: any | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, gameSeries?: { __typename?: 'GameSeries', id: any, matchType: MatchType, homeTeamId?: any | null, awayTeamId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string } | null } | null }> | null } | null };

export type GetGameSeriesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGameSeriesQuery = { __typename?: 'Query', gameSeries?: { __typename?: 'GameSeries', id: any, matchType: MatchType, status?: string | null, maxGames: number, scheduledStartTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamId?: any | null, awayTeamId?: any | null, tierId?: any | null, lobbyId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string } | null } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string } | null } | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, lobby?: { __typename?: 'MatchLobby', id: any, status: LobbyStatus, selectedMap?: string | null } | null, games?: Array<{ __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, playerStats?: Array<{ __typename?: 'PlayerMatchStats', id: any, userId: any, team: PlayerTeam, kills: number, deaths: number, assists: number, score: number, mvps: number, user: { __typename?: 'User', id: any, name: string } } | null> | null } | null> | null } | null };

export type GetGameQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGameQuery = { __typename?: 'Query', game?: { __typename?: 'Game', id: any, matchType: MatchType, map: string, status: string, scheduledTime?: any | null, startTime?: any | null, endTime?: any | null, homeTeamScore: number, awayTeamScore: number, winningTeam?: PlayerTeam | null, demoUrl?: string | null, ratingsProcessed: boolean, tierId?: any | null, lobbyId?: any | null, gameSeriesId?: any | null, serverId?: any | null, tier?: { __typename?: 'Tier', id: any, tierName: string } | null, server?: { __typename?: 'GameServer', id: any, name?: string | null, connectString?: string | null, password?: string | null } | null, lobby?: { __typename?: 'MatchLobby', id: any, status: LobbyStatus, selectedMap?: string | null, players: Array<{ __typename?: 'LobbyPlayer', id: any, team: PlayerTeam, user: { __typename?: 'User', id: any, name: string } }> } | null, gameSeries?: { __typename?: 'GameSeries', id: any, matchType: MatchType, homeTeamId?: any | null, awayTeamId?: any | null, homeTeam?: { __typename?: 'Team', id?: any | null, name: string } | null, awayTeam?: { __typename?: 'Team', id?: any | null, name: string } | null } | null, playerStats?: Array<{ __typename?: 'PlayerMatchStats', id: any, userId: any, team: PlayerTeam, kills: number, deaths: number, assists: number, score: number, mvps: number, headshotKills: number, averageDamagePerRound: number, threeKills: number, fourKills: number, fiveKills: number, user: { __typename?: 'User', id: any, name: string } } | null> | null } | null };

export type AdminRoleListQueryVariables = Exact<{
  nameFilter?: InputMaybe<Scalars['String']>;
}>;


export type AdminRoleListQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean }> };

export type AdminRoleByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminRoleByIdQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean, actions: Array<{ __typename?: 'ActionRoleAssignment', id: any, action: string, roleId: any, createdAt: any }> } | null };

export type AdminAuthActionsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
}>;


export type AdminAuthActionsQuery = { __typename?: 'Query', authActions: Array<{ __typename?: 'AuthAction', key: string, description?: string | null, category?: string | null }> };

export type AdminActionCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminActionCategoriesQuery = { __typename?: 'Query', actionCategories: Array<string> };

export type AdminRoleUsersQueryVariables = Exact<{
  roleId: Scalars['UUID'];
  includeExpired?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminRoleUsersQuery = { __typename?: 'Query', roleUsers: Array<{ __typename?: 'UserRole', id: any, userId: any, roleId: any, startDate: any, endDate?: any | null, user?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null } | null }> };

export type AdminDiscoveredActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDiscoveredActionsQuery = { __typename?: 'Query', discoveredActions: Array<{ __typename?: 'DiscoveredAction', key: string, className: string, methodName: string, category?: string | null }> };

export type AdminOrphanedActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOrphanedActionsQuery = { __typename?: 'Query', orphanedActions: Array<{ __typename?: 'AuthAction', key: string, description?: string | null, category?: string | null }> };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'RoleMutationResult', success: boolean, errorMessage?: string | null, role?: { __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean } | null } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'RoleMutationResult', success: boolean, errorMessage?: string | null, role?: { __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean } | null } };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'RoleMutationResult', success: boolean, errorMessage?: string | null } };

export type AssignActionToRoleMutationVariables = Exact<{
  roleId: Scalars['UUID'];
  actionKey: Scalars['String'];
}>;


export type AssignActionToRoleMutation = { __typename?: 'Mutation', assignActionToRole: { __typename?: 'ActionAssignmentResult', success: boolean, errorMessage?: string | null } };

export type UnassignActionFromRoleMutationVariables = Exact<{
  roleId: Scalars['UUID'];
  actionKey: Scalars['String'];
}>;


export type UnassignActionFromRoleMutation = { __typename?: 'Mutation', unassignActionFromRole: { __typename?: 'ActionAssignmentResult', success: boolean, errorMessage?: string | null } };

export type SyncDiscoveredActionsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncDiscoveredActionsMutation = { __typename?: 'Mutation', syncDiscoveredActions: { __typename?: 'ActionSyncResult', alreadyExist: Array<string>, totalDiscovered: number, created: Array<{ __typename?: 'AuthAction', key: string, description?: string | null, category?: string | null }> } };

export type AdminSeasonListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SeasonStatus>;
}>;


export type AdminSeasonListQuery = { __typename?: 'Query', seasons?: { __typename?: 'SeasonsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Season', id: any, seasonNumber: number, displayName: string, tag: string, slug?: string | null, description?: string | null, status: SeasonStatus, startsAt: any, endsAt: any, visibleFrom?: any | null, visibleTo?: any | null, createdAt: any, updatedAt: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AdminSeasonByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminSeasonByIdQuery = { __typename?: 'Query', season?: { __typename?: 'Season', id: any, seasonNumber: number, displayName: string, tag: string, slug?: string | null, description?: string | null, status: SeasonStatus, startsAt: any, endsAt: any, visibleFrom?: any | null, visibleTo?: any | null, createdAt: any, updatedAt: any } | null };

export type CurrentSeasonQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSeasonQuery = { __typename?: 'Query', currentSeason?: { __typename?: 'Season', id: any, seasonNumber: number, displayName: string, tag: string, status: SeasonStatus, startsAt: any, endsAt: any } | null };

export type CreateSeasonMutationVariables = Exact<{
  input: CreateSeasonInput;
}>;


export type CreateSeasonMutation = { __typename?: 'Mutation', createSeason: { __typename?: 'Season', id: any, seasonNumber: number, displayName: string, tag: string, slug?: string | null, status: SeasonStatus, startsAt: any, endsAt: any } };

export type UpdateSeasonMutationVariables = Exact<{
  input: UpdateSeasonInput;
}>;


export type UpdateSeasonMutation = { __typename?: 'Mutation', updateSeason: { __typename?: 'Season', id: any, seasonNumber: number, displayName: string, tag: string, slug?: string | null, description?: string | null, status: SeasonStatus, startsAt: any, endsAt: any, visibleFrom?: any | null, visibleTo?: any | null } };

export type PublishSeasonMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublishSeasonMutation = { __typename?: 'Mutation', publishSeason: boolean };

export type ActivateSeasonMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ActivateSeasonMutation = { __typename?: 'Mutation', activateSeason: boolean };

export type ConcludeSeasonMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ConcludeSeasonMutation = { __typename?: 'Mutation', concludeSeason: boolean };

export type ArchiveSeasonMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ArchiveSeasonMutation = { __typename?: 'Mutation', archiveSeason: boolean };

export type AdminSessionListQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminSessionListQuery = { __typename?: 'Query', listSessions: Array<{ __typename?: 'RefreshToken', seqId: any, isActive: boolean, token: string, ttlMinutes: number, createdAt: any, userId: any, lastAccessedAt: any, revokedAt?: any | null, deviceId?: string | null, sessionDetails?: { __typename?: 'SessionDetails', ipAddress?: string | null, userAgent?: string | null } | null }> };

export type RevokeRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RevokeRefreshTokenMutation = { __typename?: 'Mutation', revokeRefreshToken: boolean };

export type GetPublicSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicSettingsQuery = { __typename?: 'Query', publicSettings: Array<{ __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any }> };

export type GetSettingQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GetSettingQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any, createdAt: any } | null };

export type GetSettingsQueryVariables = Exact<{
  paths: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetSettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any }> };

export type GetSettingsByPathQueryVariables = Exact<{
  pathPrefix: Scalars['String'];
  depth?: InputMaybe<Scalars['Int']>;
}>;


export type GetSettingsByPathQuery = { __typename?: 'Query', settingsByPath: Array<{ __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any }> };

export type ListAllSettingsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ListAllSettingsQuery = { __typename?: 'Query', listAllSettings?: { __typename?: 'ListAllSettingsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any, createdAt: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UpsertSettingMutationVariables = Exact<{
  input: UpsertSettingInput;
}>;


export type UpsertSettingMutation = { __typename?: 'Mutation', settings: { __typename?: 'SettingsMutations', upsertSetting: { __typename?: 'Setting', path: string, value: string, dataType: SettingDataType, visibility: SettingVisibility, description?: string | null, modifiedAt: any } } };

export type DeleteSettingMutationVariables = Exact<{
  path: Scalars['String'];
}>;


export type DeleteSettingMutation = { __typename?: 'Mutation', settings: { __typename?: 'SettingsMutations', deleteSetting: boolean } };

export type BulkUpsertSettingsMutationVariables = Exact<{
  settings: Array<UpsertSettingInput> | UpsertSettingInput;
}>;


export type BulkUpsertSettingsMutation = { __typename?: 'Mutation', settings: { __typename?: 'SettingsMutations', bulkUpsertSettings: Array<{ __typename?: 'Setting', path: string, value: string, dataType: SettingDataType }> } };

export type ListTeamsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeamFilterInput>;
  order?: InputMaybe<Array<TeamSortInput> | TeamSortInput>;
}>;


export type ListTeamsQuery = { __typename?: 'Query', teams?: { __typename?: 'TeamsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Team', id?: any | null, name: string, active: boolean, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, players: Array<{ __typename?: 'User', id: any, name: string }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type TeamDetailsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type TeamDetailsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id?: any | null, name: string, active: boolean, tier?: string | null, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null, GM?: { __typename?: 'User', id: any, name: string } | null, AGM?: { __typename?: 'User', id: any, name: string } | null } | null, players: Array<{ __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null, roles?: Array<string | null> | null, isCaptain: boolean }> } | null };

export type UserTeamsQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserTeamsQuery = { __typename?: 'Query', teams?: { __typename?: 'TeamsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Team', id?: any | null, name: string, tier?: string | null, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null }> | null } | null };

export type AddTeamMutationVariables = Exact<{
  franchiseId: Scalars['UUID'];
  teamName: Scalars['String'];
}>;


export type AddTeamMutation = { __typename?: 'Mutation', addTeam: { __typename?: 'Team', id?: any | null, name: string, active: boolean, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null } };

export type UpdateTeamNameMutationVariables = Exact<{
  teamId: Scalars['UUID'];
  teamName: Scalars['String'];
}>;


export type UpdateTeamNameMutation = { __typename?: 'Mutation', updateTeamName: { __typename?: 'Team', id?: any | null, name: string, active: boolean, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null } };

export type SetTeamActiveMutationVariables = Exact<{
  teamId: Scalars['UUID'];
  active: Scalars['Boolean'];
}>;


export type SetTeamActiveMutation = { __typename?: 'Mutation', setTeamActive: { __typename?: 'Team', id?: any | null, name: string, active: boolean, franchiseId: any, franchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null } };

export type AddPlayerToTeamMutationVariables = Exact<{
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type AddPlayerToTeamMutation = { __typename?: 'Mutation', addPlayerToTeam: { __typename?: 'Team', id?: any | null, name: string, players: Array<{ __typename?: 'User', id: any, name: string, avatarUrl?: string | null, isCaptain: boolean }> } };

export type RemovePlayerFromTeamMutationVariables = Exact<{
  teamId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type RemovePlayerFromTeamMutation = { __typename?: 'Mutation', removePlayerFromTeam: { __typename?: 'Team', id?: any | null, name: string, players: Array<{ __typename?: 'User', id: any, name: string, avatarUrl?: string | null, isCaptain: boolean }> } };

export type SetTeamCaptainMutationVariables = Exact<{
  teamId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type SetTeamCaptainMutation = { __typename?: 'Mutation', setTeamCaptain: { __typename?: 'Team', id?: any | null, name: string, players: Array<{ __typename?: 'User', id: any, name: string, isCaptain: boolean }> } };

export type TransactionFieldsFragment = { __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> };

export type PendingLeagueStaffApprovalsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
  order?: InputMaybe<Array<TransactionSortInput> | TransactionSortInput>;
}>;


export type PendingLeagueStaffApprovalsQuery = { __typename?: 'Query', pendingLeagueStaffApprovals?: { __typename?: 'PendingLeagueStaffApprovalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type TransactionDetailsQueryVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type TransactionDetailsQuery = { __typename?: 'Query', transaction?: { __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> } | null };

export type PendingTransactionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  franchiseId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<TransactionFilterInput>;
  order?: InputMaybe<Array<TransactionSortInput> | TransactionSortInput>;
}>;


export type PendingTransactionsQuery = { __typename?: 'Query', pendingTransactions?: { __typename?: 'PendingTransactionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PendingFranchiseApprovalsQueryVariables = Exact<{
  franchiseId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionFilterInput>;
  order?: InputMaybe<Array<TransactionSortInput> | TransactionSortInput>;
}>;


export type PendingFranchiseApprovalsQuery = { __typename?: 'Query', pendingFranchiseApprovals?: { __typename?: 'PendingFranchiseApprovalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ExecutedTransactionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  franchiseId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<TransactionFilterInput>;
  order?: InputMaybe<Array<TransactionSortInput> | TransactionSortInput>;
}>;


export type ExecutedTransactionsQuery = { __typename?: 'Query', transactions?: { __typename?: 'TransactionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SetTransactionApprovalStatusMutationVariables = Exact<{
  input: SetTransactionApprovalInput;
}>;


export type SetTransactionApprovalStatusMutation = { __typename?: 'Mutation', setTransactionApprovalStatus: { __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null } };

export type ExecuteTransactionMutationVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type ExecuteTransactionMutation = { __typename?: 'Mutation', executeTransaction: { __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> } };

export type DeleteTransactionMutationVariables = Exact<{
  transactionId: Scalars['UUID'];
}>;


export type DeleteTransactionMutation = { __typename?: 'Mutation', deleteTransaction: { __typename?: 'Transaction', id: any } };

export type CreateTransactionMutationVariables = Exact<{
  input: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'Transaction', id: any, transactionType: TransactionType, dateSubmitted: any, dateExecuted?: any | null, notes?: string | null, submitter: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null }, submittingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, tradePartnerFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null, logoUrl?: string | null } | null, transactionItems: Array<{ __typename?: 'TransactionItem', id: any, itemOwner?: { __typename?: 'Team', id?: any | null, name: string } | null, itemReceiver?: { __typename?: 'Team', id?: any | null, name: string } | null, player?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, mmr?: number | null } | null }>, transactionApprovals: Array<{ __typename?: 'TransactionApproval', id: any, approvalStatus: ApprovalStatus, approvalDate?: any | null, isLeagueStaffApproval: boolean, isFranchiseStaffApproval: boolean, notes?: string | null, approver?: { __typename?: 'User', id: any, name: string } | null, approvingFranchise?: { __typename?: 'Franchise', id: any, name: string, prefix?: string | null } | null }> } };

export type RefreshMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshMutation = { __typename?: 'Mutation', refresh: { __typename?: 'LoginPayload', isAuthenticated: boolean, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null } | null } };

export type SignupUserMutationVariables = Exact<{
  authCode: Scalars['String'];
  redirectUri: Scalars['String'];
}>;


export type SignupUserMutation = { __typename?: 'Mutation', signup: { __typename?: 'SignupPayload', token?: string | null, outcome: SignupPayloadOutcome, user?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null } | null } };

export type LoginMutationVariables = Exact<{
  authCode: Scalars['String'];
  redirectUri: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', token?: string | null, isAuthenticated: boolean, refreshToken?: string | null, user?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, roles?: Array<string | null> | null } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserMePayload', userData: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, roles?: Array<string | null> | null } } };

export type UserByIdQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: any, name: string, avatarUrl?: string | null, roles?: Array<string | null> | null, roleNames?: Array<string> | null } | null };

export type AdminUserListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AdminUserListQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: any, name: string, roles?: Array<string | null> | null, isBanned: boolean, isSuspended: boolean, isWatchlist: boolean }> | null } | null };

export type UserSearchQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type UserSearchQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', items?: Array<{ __typename?: 'User', id: any, name: string }> | null } | null };

export type AdminUserByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AdminUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: any, name: string, roles?: Array<string | null> | null, isBanned: boolean, isSuspended: boolean, isWatchlist: boolean, assignedRoles?: Array<{ __typename?: 'Role', id: any, name: string, description: string, color: string, iconUrl: string, isSystem: boolean } | null> | null, adminMemos?: Array<{ __typename?: 'AdminMemo', id: any, text?: string | null, userId: any, timestamp: any, operatorLabel?: string | null, admin?: { __typename?: 'User', name: string } | null } | null> | null } | null };

export type AdminAddUserMemoMutationVariables = Exact<{
  userId: Scalars['UUID'];
  memo: Scalars['String'];
}>;


export type AdminAddUserMemoMutation = { __typename?: 'Mutation', addUserMemo: boolean };

export type AdminUserMemosQueryVariables = Exact<{
  userId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AdminUserMemosQuery = { __typename?: 'Query', userAdminMemos?: { __typename?: 'UserAdminMemosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'AdminMemo', id: any, text?: string | null, userId: any, timestamp: any, operatorLabel?: string | null, admin?: { __typename?: 'User', name: string } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ListUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type ListUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: any, name: string, avatarUrl?: string | null, roles?: Array<string | null> | null, roleNames?: Array<string> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SetUserFlagsMutationVariables = Exact<{
  userId: Scalars['UUID'];
  isBanned?: InputMaybe<Scalars['Boolean']>;
  isSuspended?: InputMaybe<Scalars['Boolean']>;
  isWatchlist?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetUserFlagsMutation = { __typename?: 'Mutation', setUserFlags: { __typename?: 'SetUserFlagsPayload', success: boolean, errorMessage?: string | null, user?: { __typename?: 'User', id: any, isBanned: boolean, isSuspended: boolean, isWatchlist: boolean } | null } };

export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  id
  transactionType
  dateSubmitted
  dateExecuted
  notes
  submitter {
    id
    name
    avatarUrl
  }
  submittingFranchise {
    id
    name
    prefix
    logoUrl
  }
  tradePartnerFranchise {
    id
    name
    prefix
    logoUrl
  }
  transactionItems {
    id
    itemOwner {
      id
      name
    }
    itemReceiver {
      id
      name
    }
    player {
      id
      name
      avatarUrl
      mmr
    }
  }
  transactionApprovals {
    id
    approvalStatus
    approvalDate
    isLeagueStaffApproval
    isFranchiseStaffApproval
    notes
    approver {
      id
      name
    }
    approvingFranchise {
      id
      name
      prefix
    }
  }
}
    `;
export const GetMyActionsDocument = gql`
    query GetMyActions {
  myActions
}
    `;

/**
 * __useGetMyActionsQuery__
 *
 * To run a query within a React component, call `useGetMyActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyActionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyActionsQuery, GetMyActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyActionsQuery, GetMyActionsQueryVariables>(GetMyActionsDocument, options);
      }
export function useGetMyActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyActionsQuery, GetMyActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyActionsQuery, GetMyActionsQueryVariables>(GetMyActionsDocument, options);
        }
export type GetMyActionsQueryHookResult = ReturnType<typeof useGetMyActionsQuery>;
export type GetMyActionsLazyQueryHookResult = ReturnType<typeof useGetMyActionsLazyQuery>;
export type GetMyActionsQueryResult = Apollo.QueryResult<GetMyActionsQuery, GetMyActionsQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles {
  roles {
    id
    name
    description
    color
    iconUrl
    isSystem
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const AssignRoleToUserDocument = gql`
    mutation AssignRoleToUser($userId: UUID!, $roleId: UUID!, $startDate: DateTime, $endDate: DateTime) {
  assignRoleToUser(
    userId: $userId
    roleId: $roleId
    startDate: $startDate
    endDate: $endDate
  ) {
    success
    errorMessage
    userRole {
      id
      userId
      roleId
      startDate
      endDate
    }
  }
}
    `;
export type AssignRoleToUserMutationFn = Apollo.MutationFunction<AssignRoleToUserMutation, AssignRoleToUserMutationVariables>;

/**
 * __useAssignRoleToUserMutation__
 *
 * To run a mutation, you first call `useAssignRoleToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleToUserMutation, { data, loading, error }] = useAssignRoleToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAssignRoleToUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleToUserMutation, AssignRoleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleToUserMutation, AssignRoleToUserMutationVariables>(AssignRoleToUserDocument, options);
      }
export type AssignRoleToUserMutationHookResult = ReturnType<typeof useAssignRoleToUserMutation>;
export type AssignRoleToUserMutationResult = Apollo.MutationResult<AssignRoleToUserMutation>;
export type AssignRoleToUserMutationOptions = Apollo.BaseMutationOptions<AssignRoleToUserMutation, AssignRoleToUserMutationVariables>;
export const UnassignRoleFromUserDocument = gql`
    mutation UnassignRoleFromUser($userId: UUID!, $roleId: UUID!) {
  unassignRoleFromUser(userId: $userId, roleId: $roleId) {
    success
    errorMessage
  }
}
    `;
export type UnassignRoleFromUserMutationFn = Apollo.MutationFunction<UnassignRoleFromUserMutation, UnassignRoleFromUserMutationVariables>;

/**
 * __useUnassignRoleFromUserMutation__
 *
 * To run a mutation, you first call `useUnassignRoleFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignRoleFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignRoleFromUserMutation, { data, loading, error }] = useUnassignRoleFromUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUnassignRoleFromUserMutation(baseOptions?: Apollo.MutationHookOptions<UnassignRoleFromUserMutation, UnassignRoleFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignRoleFromUserMutation, UnassignRoleFromUserMutationVariables>(UnassignRoleFromUserDocument, options);
      }
export type UnassignRoleFromUserMutationHookResult = ReturnType<typeof useUnassignRoleFromUserMutation>;
export type UnassignRoleFromUserMutationResult = Apollo.MutationResult<UnassignRoleFromUserMutation>;
export type UnassignRoleFromUserMutationOptions = Apollo.BaseMutationOptions<UnassignRoleFromUserMutation, UnassignRoleFromUserMutationVariables>;
export const MyCombineQueueStatusDocument = gql`
    query MyCombineQueueStatus {
  myCombineQueueStatus {
    isQueued
    position
    estimatedWaitTime
    tier {
      id
      tierName
    }
    queuedAt
  }
}
    `;

/**
 * __useMyCombineQueueStatusQuery__
 *
 * To run a query within a React component, call `useMyCombineQueueStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCombineQueueStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCombineQueueStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCombineQueueStatusQuery(baseOptions?: Apollo.QueryHookOptions<MyCombineQueueStatusQuery, MyCombineQueueStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCombineQueueStatusQuery, MyCombineQueueStatusQueryVariables>(MyCombineQueueStatusDocument, options);
      }
export function useMyCombineQueueStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCombineQueueStatusQuery, MyCombineQueueStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCombineQueueStatusQuery, MyCombineQueueStatusQueryVariables>(MyCombineQueueStatusDocument, options);
        }
export type MyCombineQueueStatusQueryHookResult = ReturnType<typeof useMyCombineQueueStatusQuery>;
export type MyCombineQueueStatusLazyQueryHookResult = ReturnType<typeof useMyCombineQueueStatusLazyQuery>;
export type MyCombineQueueStatusQueryResult = Apollo.QueryResult<MyCombineQueueStatusQuery, MyCombineQueueStatusQueryVariables>;
export const MyActiveCombineLobbyDocument = gql`
    query MyActiveCombineLobby {
  myActiveCombineLobby {
    id
    lobbyType
    tier {
      id
      tierName
    }
    status
    createdAt
    expiresAt
    selectedMap
    mapPool
    players {
      id
      user {
        id
        name
      }
      team
      isReady
      isConnected
      joinedAt
    }
    mapBans {
      id
      team
      type
      mapName
      order
      timestamp
    }
    server {
      id
      name
      connectString
      password
      status
    }
    currentAction {
      type
      team
      timeoutAt
    }
  }
}
    `;

/**
 * __useMyActiveCombineLobbyQuery__
 *
 * To run a query within a React component, call `useMyActiveCombineLobbyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyActiveCombineLobbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyActiveCombineLobbyQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyActiveCombineLobbyQuery(baseOptions?: Apollo.QueryHookOptions<MyActiveCombineLobbyQuery, MyActiveCombineLobbyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyActiveCombineLobbyQuery, MyActiveCombineLobbyQueryVariables>(MyActiveCombineLobbyDocument, options);
      }
export function useMyActiveCombineLobbyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyActiveCombineLobbyQuery, MyActiveCombineLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyActiveCombineLobbyQuery, MyActiveCombineLobbyQueryVariables>(MyActiveCombineLobbyDocument, options);
        }
export type MyActiveCombineLobbyQueryHookResult = ReturnType<typeof useMyActiveCombineLobbyQuery>;
export type MyActiveCombineLobbyLazyQueryHookResult = ReturnType<typeof useMyActiveCombineLobbyLazyQuery>;
export type MyActiveCombineLobbyQueryResult = Apollo.QueryResult<MyActiveCombineLobbyQuery, MyActiveCombineLobbyQueryVariables>;
export const ActiveCombineMatchesDocument = gql`
    query ActiveCombineMatches($tierId: UUID) {
  activeCombineMatches(tierId: $tierId) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    server {
      id
      name
      connectString
    }
  }
}
    `;

/**
 * __useActiveCombineMatchesQuery__
 *
 * To run a query within a React component, call `useActiveCombineMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCombineMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCombineMatchesQuery({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useActiveCombineMatchesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveCombineMatchesQuery, ActiveCombineMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveCombineMatchesQuery, ActiveCombineMatchesQueryVariables>(ActiveCombineMatchesDocument, options);
      }
export function useActiveCombineMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveCombineMatchesQuery, ActiveCombineMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveCombineMatchesQuery, ActiveCombineMatchesQueryVariables>(ActiveCombineMatchesDocument, options);
        }
export type ActiveCombineMatchesQueryHookResult = ReturnType<typeof useActiveCombineMatchesQuery>;
export type ActiveCombineMatchesLazyQueryHookResult = ReturnType<typeof useActiveCombineMatchesLazyQuery>;
export type ActiveCombineMatchesQueryResult = Apollo.QueryResult<ActiveCombineMatchesQuery, ActiveCombineMatchesQueryVariables>;
export const MyCombineMatchHistoryDocument = gql`
    query MyCombineMatchHistory($limit: Int, $offset: Int) {
  myCombineMatchHistory(limit: $limit, offset: $offset) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    demoUrl
  }
}
    `;

/**
 * __useMyCombineMatchHistoryQuery__
 *
 * To run a query within a React component, call `useMyCombineMatchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCombineMatchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCombineMatchHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyCombineMatchHistoryQuery(baseOptions?: Apollo.QueryHookOptions<MyCombineMatchHistoryQuery, MyCombineMatchHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCombineMatchHistoryQuery, MyCombineMatchHistoryQueryVariables>(MyCombineMatchHistoryDocument, options);
      }
export function useMyCombineMatchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCombineMatchHistoryQuery, MyCombineMatchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCombineMatchHistoryQuery, MyCombineMatchHistoryQueryVariables>(MyCombineMatchHistoryDocument, options);
        }
export type MyCombineMatchHistoryQueryHookResult = ReturnType<typeof useMyCombineMatchHistoryQuery>;
export type MyCombineMatchHistoryLazyQueryHookResult = ReturnType<typeof useMyCombineMatchHistoryLazyQuery>;
export type MyCombineMatchHistoryQueryResult = Apollo.QueryResult<MyCombineMatchHistoryQuery, MyCombineMatchHistoryQueryVariables>;
export const MatchDocument = gql`
    query Match($id: UUID!) {
  match(id: $id) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    demoUrl
    ratingsProcessed
    server {
      id
      name
      connectString
      password
    }
    lobby {
      id
      status
      players {
        id
        user {
          id
          name
        }
        team
      }
    }
    playerStats {
      id
      userId
      team
      kills
      deaths
      assists
      score
      mvps
      headshotKills
      averageDamagePerRound
      threeKills
      fourKills
      fiveKills
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMatchQuery__
 *
 * To run a query within a React component, call `useMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchQuery(baseOptions: Apollo.QueryHookOptions<MatchQuery, MatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
      }
export function useMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchQuery, MatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchQuery, MatchQueryVariables>(MatchDocument, options);
        }
export type MatchQueryHookResult = ReturnType<typeof useMatchQuery>;
export type MatchLazyQueryHookResult = ReturnType<typeof useMatchLazyQuery>;
export type MatchQueryResult = Apollo.QueryResult<MatchQuery, MatchQueryVariables>;
export const TeamMatchesDocument = gql`
    query TeamMatches($teamId: UUID!, $matchType: MatchType, $limit: Int, $offset: Int) {
  teamMatches(
    teamId: $teamId
    matchType: $matchType
    limit: $limit
    offset: $offset
  ) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    gameSeries {
      id
      homeTeamId
      awayTeamId
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTeamMatchesQuery__
 *
 * To run a query within a React component, call `useTeamMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMatchesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      matchType: // value for 'matchType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTeamMatchesQuery(baseOptions: Apollo.QueryHookOptions<TeamMatchesQuery, TeamMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMatchesQuery, TeamMatchesQueryVariables>(TeamMatchesDocument, options);
      }
export function useTeamMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMatchesQuery, TeamMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMatchesQuery, TeamMatchesQueryVariables>(TeamMatchesDocument, options);
        }
export type TeamMatchesQueryHookResult = ReturnType<typeof useTeamMatchesQuery>;
export type TeamMatchesLazyQueryHookResult = ReturnType<typeof useTeamMatchesLazyQuery>;
export type TeamMatchesQueryResult = Apollo.QueryResult<TeamMatchesQuery, TeamMatchesQueryVariables>;
export const FranchiseMatchesDocument = gql`
    query FranchiseMatches($franchiseId: UUID!, $matchType: MatchType, $limit: Int, $offset: Int) {
  franchiseMatches(
    franchiseId: $franchiseId
    matchType: $matchType
    limit: $limit
    offset: $offset
  ) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    gameSeries {
      id
      homeTeamId
      awayTeamId
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFranchiseMatchesQuery__
 *
 * To run a query within a React component, call `useFranchiseMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseMatchesQuery({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      matchType: // value for 'matchType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFranchiseMatchesQuery(baseOptions: Apollo.QueryHookOptions<FranchiseMatchesQuery, FranchiseMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchiseMatchesQuery, FranchiseMatchesQueryVariables>(FranchiseMatchesDocument, options);
      }
export function useFranchiseMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchiseMatchesQuery, FranchiseMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchiseMatchesQuery, FranchiseMatchesQueryVariables>(FranchiseMatchesDocument, options);
        }
export type FranchiseMatchesQueryHookResult = ReturnType<typeof useFranchiseMatchesQuery>;
export type FranchiseMatchesLazyQueryHookResult = ReturnType<typeof useFranchiseMatchesLazyQuery>;
export type FranchiseMatchesQueryResult = Apollo.QueryResult<FranchiseMatchesQuery, FranchiseMatchesQueryVariables>;
export const CombineMapPoolDocument = gql`
    query CombineMapPool($tierId: UUID!) {
  combineMapPool(tierId: $tierId)
}
    `;

/**
 * __useCombineMapPoolQuery__
 *
 * To run a query within a React component, call `useCombineMapPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useCombineMapPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombineMapPoolQuery({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useCombineMapPoolQuery(baseOptions: Apollo.QueryHookOptions<CombineMapPoolQuery, CombineMapPoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CombineMapPoolQuery, CombineMapPoolQueryVariables>(CombineMapPoolDocument, options);
      }
export function useCombineMapPoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CombineMapPoolQuery, CombineMapPoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CombineMapPoolQuery, CombineMapPoolQueryVariables>(CombineMapPoolDocument, options);
        }
export type CombineMapPoolQueryHookResult = ReturnType<typeof useCombineMapPoolQuery>;
export type CombineMapPoolLazyQueryHookResult = ReturnType<typeof useCombineMapPoolLazyQuery>;
export type CombineMapPoolQueryResult = Apollo.QueryResult<CombineMapPoolQuery, CombineMapPoolQueryVariables>;
export const JoinCombineQueueDocument = gql`
    mutation JoinCombineQueue {
  joinCombineQueue {
    success
    queueId
    position
    message
  }
}
    `;
export type JoinCombineQueueMutationFn = Apollo.MutationFunction<JoinCombineQueueMutation, JoinCombineQueueMutationVariables>;

/**
 * __useJoinCombineQueueMutation__
 *
 * To run a mutation, you first call `useJoinCombineQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCombineQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCombineQueueMutation, { data, loading, error }] = useJoinCombineQueueMutation({
 *   variables: {
 *   },
 * });
 */
export function useJoinCombineQueueMutation(baseOptions?: Apollo.MutationHookOptions<JoinCombineQueueMutation, JoinCombineQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCombineQueueMutation, JoinCombineQueueMutationVariables>(JoinCombineQueueDocument, options);
      }
export type JoinCombineQueueMutationHookResult = ReturnType<typeof useJoinCombineQueueMutation>;
export type JoinCombineQueueMutationResult = Apollo.MutationResult<JoinCombineQueueMutation>;
export type JoinCombineQueueMutationOptions = Apollo.BaseMutationOptions<JoinCombineQueueMutation, JoinCombineQueueMutationVariables>;
export const LeaveCombineQueueDocument = gql`
    mutation LeaveCombineQueue {
  leaveCombineQueue
}
    `;
export type LeaveCombineQueueMutationFn = Apollo.MutationFunction<LeaveCombineQueueMutation, LeaveCombineQueueMutationVariables>;

/**
 * __useLeaveCombineQueueMutation__
 *
 * To run a mutation, you first call `useLeaveCombineQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCombineQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCombineQueueMutation, { data, loading, error }] = useLeaveCombineQueueMutation({
 *   variables: {
 *   },
 * });
 */
export function useLeaveCombineQueueMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCombineQueueMutation, LeaveCombineQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCombineQueueMutation, LeaveCombineQueueMutationVariables>(LeaveCombineQueueDocument, options);
      }
export type LeaveCombineQueueMutationHookResult = ReturnType<typeof useLeaveCombineQueueMutation>;
export type LeaveCombineQueueMutationResult = Apollo.MutationResult<LeaveCombineQueueMutation>;
export type LeaveCombineQueueMutationOptions = Apollo.BaseMutationOptions<LeaveCombineQueueMutation, LeaveCombineQueueMutationVariables>;
export const AcknowledgeCombineLobbyDocument = gql`
    mutation AcknowledgeCombineLobby($lobbyId: UUID!) {
  acknowledgeCombineLobby(lobbyId: $lobbyId)
}
    `;
export type AcknowledgeCombineLobbyMutationFn = Apollo.MutationFunction<AcknowledgeCombineLobbyMutation, AcknowledgeCombineLobbyMutationVariables>;

/**
 * __useAcknowledgeCombineLobbyMutation__
 *
 * To run a mutation, you first call `useAcknowledgeCombineLobbyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeCombineLobbyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeCombineLobbyMutation, { data, loading, error }] = useAcknowledgeCombineLobbyMutation({
 *   variables: {
 *      lobbyId: // value for 'lobbyId'
 *   },
 * });
 */
export function useAcknowledgeCombineLobbyMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeCombineLobbyMutation, AcknowledgeCombineLobbyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeCombineLobbyMutation, AcknowledgeCombineLobbyMutationVariables>(AcknowledgeCombineLobbyDocument, options);
      }
export type AcknowledgeCombineLobbyMutationHookResult = ReturnType<typeof useAcknowledgeCombineLobbyMutation>;
export type AcknowledgeCombineLobbyMutationResult = Apollo.MutationResult<AcknowledgeCombineLobbyMutation>;
export type AcknowledgeCombineLobbyMutationOptions = Apollo.BaseMutationOptions<AcknowledgeCombineLobbyMutation, AcknowledgeCombineLobbyMutationVariables>;
export const ReadyUpInLobbyDocument = gql`
    mutation ReadyUpInLobby($lobbyId: UUID!) {
  readyUpInLobby(lobbyId: $lobbyId)
}
    `;
export type ReadyUpInLobbyMutationFn = Apollo.MutationFunction<ReadyUpInLobbyMutation, ReadyUpInLobbyMutationVariables>;

/**
 * __useReadyUpInLobbyMutation__
 *
 * To run a mutation, you first call `useReadyUpInLobbyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadyUpInLobbyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readyUpInLobbyMutation, { data, loading, error }] = useReadyUpInLobbyMutation({
 *   variables: {
 *      lobbyId: // value for 'lobbyId'
 *   },
 * });
 */
export function useReadyUpInLobbyMutation(baseOptions?: Apollo.MutationHookOptions<ReadyUpInLobbyMutation, ReadyUpInLobbyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadyUpInLobbyMutation, ReadyUpInLobbyMutationVariables>(ReadyUpInLobbyDocument, options);
      }
export type ReadyUpInLobbyMutationHookResult = ReturnType<typeof useReadyUpInLobbyMutation>;
export type ReadyUpInLobbyMutationResult = Apollo.MutationResult<ReadyUpInLobbyMutation>;
export type ReadyUpInLobbyMutationOptions = Apollo.BaseMutationOptions<ReadyUpInLobbyMutation, ReadyUpInLobbyMutationVariables>;
export const BanMapDocument = gql`
    mutation BanMap($lobbyId: UUID!, $mapName: String!) {
  banMap(lobbyId: $lobbyId, mapName: $mapName) {
    success
    message
  }
}
    `;
export type BanMapMutationFn = Apollo.MutationFunction<BanMapMutation, BanMapMutationVariables>;

/**
 * __useBanMapMutation__
 *
 * To run a mutation, you first call `useBanMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banMapMutation, { data, loading, error }] = useBanMapMutation({
 *   variables: {
 *      lobbyId: // value for 'lobbyId'
 *      mapName: // value for 'mapName'
 *   },
 * });
 */
export function useBanMapMutation(baseOptions?: Apollo.MutationHookOptions<BanMapMutation, BanMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanMapMutation, BanMapMutationVariables>(BanMapDocument, options);
      }
export type BanMapMutationHookResult = ReturnType<typeof useBanMapMutation>;
export type BanMapMutationResult = Apollo.MutationResult<BanMapMutation>;
export type BanMapMutationOptions = Apollo.BaseMutationOptions<BanMapMutation, BanMapMutationVariables>;
export const CombineQueueUpdatedDocument = gql`
    subscription CombineQueueUpdated {
  queueStatusUpdated {
    isQueued
    position
    estimatedWaitTime
    tier {
      id
      tierName
    }
    queuedAt
  }
}
    `;

/**
 * __useCombineQueueUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombineQueueUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombineQueueUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombineQueueUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCombineQueueUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CombineQueueUpdatedSubscription, CombineQueueUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombineQueueUpdatedSubscription, CombineQueueUpdatedSubscriptionVariables>(CombineQueueUpdatedDocument, options);
      }
export type CombineQueueUpdatedSubscriptionHookResult = ReturnType<typeof useCombineQueueUpdatedSubscription>;
export type CombineQueueUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombineQueueUpdatedSubscription>;
export const CombineLobbyUpdatedDocument = gql`
    subscription CombineLobbyUpdated($lobbyId: UUID!) {
  lobbyUpdated(lobbyId: $lobbyId) {
    id
    lobbyType
    tier {
      id
      tierName
    }
    status
    createdAt
    expiresAt
    selectedMap
    mapPool
    players {
      id
      user {
        id
        name
      }
      team
      isReady
      isConnected
      joinedAt
    }
    mapBans {
      id
      team
      type
      mapName
      order
      timestamp
    }
    server {
      id
      name
      connectString
      password
      status
    }
    currentAction {
      type
      team
      timeoutAt
    }
  }
}
    `;

/**
 * __useCombineLobbyUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombineLobbyUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombineLobbyUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombineLobbyUpdatedSubscription({
 *   variables: {
 *      lobbyId: // value for 'lobbyId'
 *   },
 * });
 */
export function useCombineLobbyUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombineLobbyUpdatedSubscription, CombineLobbyUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombineLobbyUpdatedSubscription, CombineLobbyUpdatedSubscriptionVariables>(CombineLobbyUpdatedDocument, options);
      }
export type CombineLobbyUpdatedSubscriptionHookResult = ReturnType<typeof useCombineLobbyUpdatedSubscription>;
export type CombineLobbyUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombineLobbyUpdatedSubscription>;
export const CombineMatchUpdatedDocument = gql`
    subscription CombineMatchUpdated($matchId: UUID!) {
  matchUpdated(matchId: $matchId) {
    id
    matchType
    tier {
      id
      tierName
    }
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    demoUrl
    server {
      id
      name
      connectString
    }
    playerStats {
      id
      userId
      team
      kills
      deaths
      assists
      score
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCombineMatchUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombineMatchUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombineMatchUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombineMatchUpdatedSubscription({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCombineMatchUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombineMatchUpdatedSubscription, CombineMatchUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombineMatchUpdatedSubscription, CombineMatchUpdatedSubscriptionVariables>(CombineMatchUpdatedDocument, options);
      }
export type CombineMatchUpdatedSubscriptionHookResult = ReturnType<typeof useCombineMatchUpdatedSubscription>;
export type CombineMatchUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombineMatchUpdatedSubscription>;
export const ListFranchisesDocument = gql`
    query ListFranchises($skip: Int, $take: Int, $where: FranchiseFilterInput, $order: [FranchiseSortInput!]) {
  franchises(skip: $skip, take: $take, where: $where, order: $order) {
    items {
      id
      name
      active
      logoUrl
      prefix
      GM {
        id
        name
      }
      AGM {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useListFranchisesQuery__
 *
 * To run a query within a React component, call `useListFranchisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFranchisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFranchisesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListFranchisesQuery(baseOptions?: Apollo.QueryHookOptions<ListFranchisesQuery, ListFranchisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFranchisesQuery, ListFranchisesQueryVariables>(ListFranchisesDocument, options);
      }
export function useListFranchisesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFranchisesQuery, ListFranchisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFranchisesQuery, ListFranchisesQueryVariables>(ListFranchisesDocument, options);
        }
export type ListFranchisesQueryHookResult = ReturnType<typeof useListFranchisesQuery>;
export type ListFranchisesLazyQueryHookResult = ReturnType<typeof useListFranchisesLazyQuery>;
export type ListFranchisesQueryResult = Apollo.QueryResult<ListFranchisesQuery, ListFranchisesQueryVariables>;
export const CreateFranchiseDocument = gql`
    mutation CreateFranchise($name: String!) {
  createFranchise(input: {name: $name}) {
    name
    id
  }
}
    `;
export type CreateFranchiseMutationFn = Apollo.MutationFunction<CreateFranchiseMutation, CreateFranchiseMutationVariables>;

/**
 * __useCreateFranchiseMutation__
 *
 * To run a mutation, you first call `useCreateFranchiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFranchiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFranchiseMutation, { data, loading, error }] = useCreateFranchiseMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFranchiseMutation(baseOptions?: Apollo.MutationHookOptions<CreateFranchiseMutation, CreateFranchiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFranchiseMutation, CreateFranchiseMutationVariables>(CreateFranchiseDocument, options);
      }
export type CreateFranchiseMutationHookResult = ReturnType<typeof useCreateFranchiseMutation>;
export type CreateFranchiseMutationResult = Apollo.MutationResult<CreateFranchiseMutation>;
export type CreateFranchiseMutationOptions = Apollo.BaseMutationOptions<CreateFranchiseMutation, CreateFranchiseMutationVariables>;
export const FranchiseDetailsDocument = gql`
    query FranchiseDetails($franchiseId: UUID!) {
  franchise(id: $franchiseId) {
    name
    id
    active
    prefix
    logoUrl
    GM {
      name
      id
    }
    GMStaffPosition {
      id
      positionCode
      positionCategory
      priority
    }
    AGM {
      name
      id
    }
    AGMStaffPosition {
      id
      positionCode
      positionCategory
      priority
    }
  }
}
    `;

/**
 * __useFranchiseDetailsQuery__
 *
 * To run a query within a React component, call `useFranchiseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseDetailsQuery({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *   },
 * });
 */
export function useFranchiseDetailsQuery(baseOptions: Apollo.QueryHookOptions<FranchiseDetailsQuery, FranchiseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchiseDetailsQuery, FranchiseDetailsQueryVariables>(FranchiseDetailsDocument, options);
      }
export function useFranchiseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchiseDetailsQuery, FranchiseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchiseDetailsQuery, FranchiseDetailsQueryVariables>(FranchiseDetailsDocument, options);
        }
export type FranchiseDetailsQueryHookResult = ReturnType<typeof useFranchiseDetailsQuery>;
export type FranchiseDetailsLazyQueryHookResult = ReturnType<typeof useFranchiseDetailsLazyQuery>;
export type FranchiseDetailsQueryResult = Apollo.QueryResult<FranchiseDetailsQuery, FranchiseDetailsQueryVariables>;
export const FranchiseTeamsDocument = gql`
    query FranchiseTeams($franchiseId: UUID!) {
  teams(where: {franchiseId: {equals: $franchiseId}}) {
    items {
      id
      name
      tier
      active
      players {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useFranchiseTeamsQuery__
 *
 * To run a query within a React component, call `useFranchiseTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseTeamsQuery({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *   },
 * });
 */
export function useFranchiseTeamsQuery(baseOptions: Apollo.QueryHookOptions<FranchiseTeamsQuery, FranchiseTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchiseTeamsQuery, FranchiseTeamsQueryVariables>(FranchiseTeamsDocument, options);
      }
export function useFranchiseTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchiseTeamsQuery, FranchiseTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchiseTeamsQuery, FranchiseTeamsQueryVariables>(FranchiseTeamsDocument, options);
        }
export type FranchiseTeamsQueryHookResult = ReturnType<typeof useFranchiseTeamsQuery>;
export type FranchiseTeamsLazyQueryHookResult = ReturnType<typeof useFranchiseTeamsLazyQuery>;
export type FranchiseTeamsQueryResult = Apollo.QueryResult<FranchiseTeamsQuery, FranchiseTeamsQueryVariables>;
export const UpdateFranchiseDocument = gql`
    mutation UpdateFranchise($franchiseId: UUID!, $name: String, $active: Boolean) {
  updateFranchise(
    input: {franchiseId: $franchiseId, name: $name, active: $active}
  ) {
    name
    id
  }
}
    `;
export type UpdateFranchiseMutationFn = Apollo.MutationFunction<UpdateFranchiseMutation, UpdateFranchiseMutationVariables>;

/**
 * __useUpdateFranchiseMutation__
 *
 * To run a mutation, you first call `useUpdateFranchiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFranchiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFranchiseMutation, { data, loading, error }] = useUpdateFranchiseMutation({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateFranchiseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFranchiseMutation, UpdateFranchiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFranchiseMutation, UpdateFranchiseMutationVariables>(UpdateFranchiseDocument, options);
      }
export type UpdateFranchiseMutationHookResult = ReturnType<typeof useUpdateFranchiseMutation>;
export type UpdateFranchiseMutationResult = Apollo.MutationResult<UpdateFranchiseMutation>;
export type UpdateFranchiseMutationOptions = Apollo.BaseMutationOptions<UpdateFranchiseMutation, UpdateFranchiseMutationVariables>;
export const SetFranchiseGmDocument = gql`
    mutation SetFranchiseGM($franchiseId: UUID!, $userId: UUID!) {
  setFranchiseGM(userId: $userId, franchiseId: $franchiseId) {
    successful
  }
}
    `;
export type SetFranchiseGmMutationFn = Apollo.MutationFunction<SetFranchiseGmMutation, SetFranchiseGmMutationVariables>;

/**
 * __useSetFranchiseGmMutation__
 *
 * To run a mutation, you first call `useSetFranchiseGmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFranchiseGmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFranchiseGmMutation, { data, loading, error }] = useSetFranchiseGmMutation({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetFranchiseGmMutation(baseOptions?: Apollo.MutationHookOptions<SetFranchiseGmMutation, SetFranchiseGmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFranchiseGmMutation, SetFranchiseGmMutationVariables>(SetFranchiseGmDocument, options);
      }
export type SetFranchiseGmMutationHookResult = ReturnType<typeof useSetFranchiseGmMutation>;
export type SetFranchiseGmMutationResult = Apollo.MutationResult<SetFranchiseGmMutation>;
export type SetFranchiseGmMutationOptions = Apollo.BaseMutationOptions<SetFranchiseGmMutation, SetFranchiseGmMutationVariables>;
export const SetFranchiseAgmDocument = gql`
    mutation SetFranchiseAGM($franchiseId: UUID!, $userId: UUID!) {
  setFranchiseAGM(userId: $userId, franchiseId: $franchiseId) {
    successful
  }
}
    `;
export type SetFranchiseAgmMutationFn = Apollo.MutationFunction<SetFranchiseAgmMutation, SetFranchiseAgmMutationVariables>;

/**
 * __useSetFranchiseAgmMutation__
 *
 * To run a mutation, you first call `useSetFranchiseAgmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFranchiseAgmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFranchiseAgmMutation, { data, loading, error }] = useSetFranchiseAgmMutation({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetFranchiseAgmMutation(baseOptions?: Apollo.MutationHookOptions<SetFranchiseAgmMutation, SetFranchiseAgmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFranchiseAgmMutation, SetFranchiseAgmMutationVariables>(SetFranchiseAgmDocument, options);
      }
export type SetFranchiseAgmMutationHookResult = ReturnType<typeof useSetFranchiseAgmMutation>;
export type SetFranchiseAgmMutationResult = Apollo.MutationResult<SetFranchiseAgmMutation>;
export type SetFranchiseAgmMutationOptions = Apollo.BaseMutationOptions<SetFranchiseAgmMutation, SetFranchiseAgmMutationVariables>;
export const UpdateFranchiseStaffDocument = gql`
    mutation UpdateFranchiseStaff($franchiseId: UUID!, $operation: String!, $staffId: UUID!, $userId: UUID!) {
  updateFranchiseStaff(
    franchiseId: $franchiseId
    input: {operation: $operation, staffId: $staffId, userId: $userId}
  ) {
    successful
  }
}
    `;
export type UpdateFranchiseStaffMutationFn = Apollo.MutationFunction<UpdateFranchiseStaffMutation, UpdateFranchiseStaffMutationVariables>;

/**
 * __useUpdateFranchiseStaffMutation__
 *
 * To run a mutation, you first call `useUpdateFranchiseStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFranchiseStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFranchiseStaffMutation, { data, loading, error }] = useUpdateFranchiseStaffMutation({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      operation: // value for 'operation'
 *      staffId: // value for 'staffId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateFranchiseStaffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFranchiseStaffMutation, UpdateFranchiseStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFranchiseStaffMutation, UpdateFranchiseStaffMutationVariables>(UpdateFranchiseStaffDocument, options);
      }
export type UpdateFranchiseStaffMutationHookResult = ReturnType<typeof useUpdateFranchiseStaffMutation>;
export type UpdateFranchiseStaffMutationResult = Apollo.MutationResult<UpdateFranchiseStaffMutation>;
export type UpdateFranchiseStaffMutationOptions = Apollo.BaseMutationOptions<UpdateFranchiseStaffMutation, UpdateFranchiseStaffMutationVariables>;
export const AllActiveFranchisesWithStaffDocument = gql`
    query AllActiveFranchisesWithStaff {
  franchises(where: {active: {equals: true}}, take: 50) {
    items {
      id
      name
      prefix
      logoUrl
      active
      GM {
        id
        name
        avatarUrl
      }
      AGM {
        id
        name
        avatarUrl
      }
    }
    totalCount
  }
}
    `;

/**
 * __useAllActiveFranchisesWithStaffQuery__
 *
 * To run a query within a React component, call `useAllActiveFranchisesWithStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActiveFranchisesWithStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActiveFranchisesWithStaffQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllActiveFranchisesWithStaffQuery(baseOptions?: Apollo.QueryHookOptions<AllActiveFranchisesWithStaffQuery, AllActiveFranchisesWithStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActiveFranchisesWithStaffQuery, AllActiveFranchisesWithStaffQueryVariables>(AllActiveFranchisesWithStaffDocument, options);
      }
export function useAllActiveFranchisesWithStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActiveFranchisesWithStaffQuery, AllActiveFranchisesWithStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActiveFranchisesWithStaffQuery, AllActiveFranchisesWithStaffQueryVariables>(AllActiveFranchisesWithStaffDocument, options);
        }
export type AllActiveFranchisesWithStaffQueryHookResult = ReturnType<typeof useAllActiveFranchisesWithStaffQuery>;
export type AllActiveFranchisesWithStaffLazyQueryHookResult = ReturnType<typeof useAllActiveFranchisesWithStaffLazyQuery>;
export type AllActiveFranchisesWithStaffQueryResult = Apollo.QueryResult<AllActiveFranchisesWithStaffQuery, AllActiveFranchisesWithStaffQueryVariables>;
export const GetMatchHistoryDocument = gql`
    query GetMatchHistory($where: GameSeriesFilterInput, $order: [GameSeriesSortInput!], $skip: Int, $take: Int) {
  listGameSeries(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      matchType
      status
      maxGames
      scheduledStartTime
      startTime
      endTime
      homeTeamId
      awayTeamId
      tierId
      lobbyId
      homeTeam {
        id
        name
        franchiseId
        franchise {
          id
          name
        }
      }
      awayTeam {
        id
        name
        franchiseId
        franchise {
          id
          name
        }
      }
      tier {
        id
        tierName
      }
      games {
        id
        matchType
        map
        status
        startTime
        endTime
        homeTeamScore
        awayTeamScore
        winningTeam
        demoUrl
      }
    }
  }
}
    `;

/**
 * __useGetMatchHistoryQuery__
 *
 * To run a query within a React component, call `useGetMatchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetMatchHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetMatchHistoryQuery, GetMatchHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchHistoryQuery, GetMatchHistoryQueryVariables>(GetMatchHistoryDocument, options);
      }
export function useGetMatchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchHistoryQuery, GetMatchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchHistoryQuery, GetMatchHistoryQueryVariables>(GetMatchHistoryDocument, options);
        }
export type GetMatchHistoryQueryHookResult = ReturnType<typeof useGetMatchHistoryQuery>;
export type GetMatchHistoryLazyQueryHookResult = ReturnType<typeof useGetMatchHistoryLazyQuery>;
export type GetMatchHistoryQueryResult = Apollo.QueryResult<GetMatchHistoryQuery, GetMatchHistoryQueryVariables>;
export const ListGamesDocument = gql`
    query ListGames($where: GameFilterInput, $order: [GameSortInput!], $skip: Int, $take: Int) {
  listGames(where: $where, order: $order, skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      matchType
      map
      status
      scheduledTime
      startTime
      endTime
      homeTeamScore
      awayTeamScore
      winningTeam
      demoUrl
      ratingsProcessed
      tierId
      lobbyId
      gameSeriesId
      serverId
      tier {
        id
        tierName
      }
      gameSeries {
        id
        matchType
        homeTeamId
        awayTeamId
        homeTeam {
          id
          name
        }
        awayTeam {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useListGamesQuery__
 *
 * To run a query within a React component, call `useListGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGamesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useListGamesQuery(baseOptions?: Apollo.QueryHookOptions<ListGamesQuery, ListGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGamesQuery, ListGamesQueryVariables>(ListGamesDocument, options);
      }
export function useListGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGamesQuery, ListGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGamesQuery, ListGamesQueryVariables>(ListGamesDocument, options);
        }
export type ListGamesQueryHookResult = ReturnType<typeof useListGamesQuery>;
export type ListGamesLazyQueryHookResult = ReturnType<typeof useListGamesLazyQuery>;
export type ListGamesQueryResult = Apollo.QueryResult<ListGamesQuery, ListGamesQueryVariables>;
export const GetGameSeriesDocument = gql`
    query GetGameSeries($id: UUID!) {
  gameSeries(id: $id) {
    id
    matchType
    status
    maxGames
    scheduledStartTime
    startTime
    endTime
    homeTeamId
    awayTeamId
    tierId
    lobbyId
    homeTeam {
      id
      name
      franchiseId
      franchise {
        id
        name
      }
    }
    awayTeam {
      id
      name
      franchiseId
      franchise {
        id
        name
      }
    }
    tier {
      id
      tierName
    }
    lobby {
      id
      status
      selectedMap
    }
    games {
      id
      matchType
      map
      status
      startTime
      endTime
      homeTeamScore
      awayTeamScore
      winningTeam
      demoUrl
      playerStats {
        id
        userId
        team
        kills
        deaths
        assists
        score
        mvps
        user {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetGameSeriesQuery__
 *
 * To run a query within a React component, call `useGetGameSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGameSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameSeriesQuery, GetGameSeriesQueryVariables>(GetGameSeriesDocument, options);
      }
export function useGetGameSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameSeriesQuery, GetGameSeriesQueryVariables>(GetGameSeriesDocument, options);
        }
export type GetGameSeriesQueryHookResult = ReturnType<typeof useGetGameSeriesQuery>;
export type GetGameSeriesLazyQueryHookResult = ReturnType<typeof useGetGameSeriesLazyQuery>;
export type GetGameSeriesQueryResult = Apollo.QueryResult<GetGameSeriesQuery, GetGameSeriesQueryVariables>;
export const GetGameDocument = gql`
    query GetGame($id: UUID!) {
  game(id: $id) {
    id
    matchType
    map
    status
    scheduledTime
    startTime
    endTime
    homeTeamScore
    awayTeamScore
    winningTeam
    demoUrl
    ratingsProcessed
    tierId
    lobbyId
    gameSeriesId
    serverId
    tier {
      id
      tierName
    }
    server {
      id
      name
      connectString
      password
    }
    lobby {
      id
      status
      selectedMap
      players {
        id
        user {
          id
          name
        }
        team
      }
    }
    gameSeries {
      id
      matchType
      homeTeamId
      awayTeamId
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
    }
    playerStats {
      id
      userId
      team
      kills
      deaths
      assists
      score
      mvps
      headshotKills
      averageDamagePerRound
      threeKills
      fourKills
      fiveKills
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetGameQuery__
 *
 * To run a query within a React component, call `useGetGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGameQuery(baseOptions: Apollo.QueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
      }
export function useGetGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameQuery, GetGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, options);
        }
export type GetGameQueryHookResult = ReturnType<typeof useGetGameQuery>;
export type GetGameLazyQueryHookResult = ReturnType<typeof useGetGameLazyQuery>;
export type GetGameQueryResult = Apollo.QueryResult<GetGameQuery, GetGameQueryVariables>;
export const AdminRoleListDocument = gql`
    query AdminRoleList($nameFilter: String) {
  roles(nameFilter: $nameFilter) {
    id
    name
    description
    color
    iconUrl
    isSystem
  }
}
    `;

/**
 * __useAdminRoleListQuery__
 *
 * To run a query within a React component, call `useAdminRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRoleListQuery({
 *   variables: {
 *      nameFilter: // value for 'nameFilter'
 *   },
 * });
 */
export function useAdminRoleListQuery(baseOptions?: Apollo.QueryHookOptions<AdminRoleListQuery, AdminRoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRoleListQuery, AdminRoleListQueryVariables>(AdminRoleListDocument, options);
      }
export function useAdminRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRoleListQuery, AdminRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRoleListQuery, AdminRoleListQueryVariables>(AdminRoleListDocument, options);
        }
export type AdminRoleListQueryHookResult = ReturnType<typeof useAdminRoleListQuery>;
export type AdminRoleListLazyQueryHookResult = ReturnType<typeof useAdminRoleListLazyQuery>;
export type AdminRoleListQueryResult = Apollo.QueryResult<AdminRoleListQuery, AdminRoleListQueryVariables>;
export const AdminRoleByIdDocument = gql`
    query AdminRoleById($id: UUID!) {
  role(id: $id) {
    id
    name
    description
    color
    iconUrl
    isSystem
    actions {
      id
      action
      roleId
      createdAt
    }
  }
}
    `;

/**
 * __useAdminRoleByIdQuery__
 *
 * To run a query within a React component, call `useAdminRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRoleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRoleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRoleByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminRoleByIdQuery, AdminRoleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRoleByIdQuery, AdminRoleByIdQueryVariables>(AdminRoleByIdDocument, options);
      }
export function useAdminRoleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRoleByIdQuery, AdminRoleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRoleByIdQuery, AdminRoleByIdQueryVariables>(AdminRoleByIdDocument, options);
        }
export type AdminRoleByIdQueryHookResult = ReturnType<typeof useAdminRoleByIdQuery>;
export type AdminRoleByIdLazyQueryHookResult = ReturnType<typeof useAdminRoleByIdLazyQuery>;
export type AdminRoleByIdQueryResult = Apollo.QueryResult<AdminRoleByIdQuery, AdminRoleByIdQueryVariables>;
export const AdminAuthActionsDocument = gql`
    query AdminAuthActions($category: String) {
  authActions(category: $category) {
    key
    description
    category
  }
}
    `;

/**
 * __useAdminAuthActionsQuery__
 *
 * To run a query within a React component, call `useAdminAuthActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAuthActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAuthActionsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useAdminAuthActionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminAuthActionsQuery, AdminAuthActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAuthActionsQuery, AdminAuthActionsQueryVariables>(AdminAuthActionsDocument, options);
      }
export function useAdminAuthActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAuthActionsQuery, AdminAuthActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAuthActionsQuery, AdminAuthActionsQueryVariables>(AdminAuthActionsDocument, options);
        }
export type AdminAuthActionsQueryHookResult = ReturnType<typeof useAdminAuthActionsQuery>;
export type AdminAuthActionsLazyQueryHookResult = ReturnType<typeof useAdminAuthActionsLazyQuery>;
export type AdminAuthActionsQueryResult = Apollo.QueryResult<AdminAuthActionsQuery, AdminAuthActionsQueryVariables>;
export const AdminActionCategoriesDocument = gql`
    query AdminActionCategories {
  actionCategories
}
    `;

/**
 * __useAdminActionCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminActionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminActionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminActionCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminActionCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminActionCategoriesQuery, AdminActionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminActionCategoriesQuery, AdminActionCategoriesQueryVariables>(AdminActionCategoriesDocument, options);
      }
export function useAdminActionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminActionCategoriesQuery, AdminActionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminActionCategoriesQuery, AdminActionCategoriesQueryVariables>(AdminActionCategoriesDocument, options);
        }
export type AdminActionCategoriesQueryHookResult = ReturnType<typeof useAdminActionCategoriesQuery>;
export type AdminActionCategoriesLazyQueryHookResult = ReturnType<typeof useAdminActionCategoriesLazyQuery>;
export type AdminActionCategoriesQueryResult = Apollo.QueryResult<AdminActionCategoriesQuery, AdminActionCategoriesQueryVariables>;
export const AdminRoleUsersDocument = gql`
    query AdminRoleUsers($roleId: UUID!, $includeExpired: Boolean) {
  roleUsers(roleId: $roleId, includeExpired: $includeExpired) {
    id
    userId
    roleId
    startDate
    endDate
    user {
      id
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useAdminRoleUsersQuery__
 *
 * To run a query within a React component, call `useAdminRoleUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRoleUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRoleUsersQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      includeExpired: // value for 'includeExpired'
 *   },
 * });
 */
export function useAdminRoleUsersQuery(baseOptions: Apollo.QueryHookOptions<AdminRoleUsersQuery, AdminRoleUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRoleUsersQuery, AdminRoleUsersQueryVariables>(AdminRoleUsersDocument, options);
      }
export function useAdminRoleUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRoleUsersQuery, AdminRoleUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRoleUsersQuery, AdminRoleUsersQueryVariables>(AdminRoleUsersDocument, options);
        }
export type AdminRoleUsersQueryHookResult = ReturnType<typeof useAdminRoleUsersQuery>;
export type AdminRoleUsersLazyQueryHookResult = ReturnType<typeof useAdminRoleUsersLazyQuery>;
export type AdminRoleUsersQueryResult = Apollo.QueryResult<AdminRoleUsersQuery, AdminRoleUsersQueryVariables>;
export const AdminDiscoveredActionsDocument = gql`
    query AdminDiscoveredActions {
  discoveredActions {
    key
    className
    methodName
    category
  }
}
    `;

/**
 * __useAdminDiscoveredActionsQuery__
 *
 * To run a query within a React component, call `useAdminDiscoveredActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDiscoveredActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDiscoveredActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDiscoveredActionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminDiscoveredActionsQuery, AdminDiscoveredActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDiscoveredActionsQuery, AdminDiscoveredActionsQueryVariables>(AdminDiscoveredActionsDocument, options);
      }
export function useAdminDiscoveredActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDiscoveredActionsQuery, AdminDiscoveredActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDiscoveredActionsQuery, AdminDiscoveredActionsQueryVariables>(AdminDiscoveredActionsDocument, options);
        }
export type AdminDiscoveredActionsQueryHookResult = ReturnType<typeof useAdminDiscoveredActionsQuery>;
export type AdminDiscoveredActionsLazyQueryHookResult = ReturnType<typeof useAdminDiscoveredActionsLazyQuery>;
export type AdminDiscoveredActionsQueryResult = Apollo.QueryResult<AdminDiscoveredActionsQuery, AdminDiscoveredActionsQueryVariables>;
export const AdminOrphanedActionsDocument = gql`
    query AdminOrphanedActions {
  orphanedActions {
    key
    description
    category
  }
}
    `;

/**
 * __useAdminOrphanedActionsQuery__
 *
 * To run a query within a React component, call `useAdminOrphanedActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrphanedActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrphanedActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminOrphanedActionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrphanedActionsQuery, AdminOrphanedActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrphanedActionsQuery, AdminOrphanedActionsQueryVariables>(AdminOrphanedActionsDocument, options);
      }
export function useAdminOrphanedActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrphanedActionsQuery, AdminOrphanedActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrphanedActionsQuery, AdminOrphanedActionsQueryVariables>(AdminOrphanedActionsDocument, options);
        }
export type AdminOrphanedActionsQueryHookResult = ReturnType<typeof useAdminOrphanedActionsQuery>;
export type AdminOrphanedActionsLazyQueryHookResult = ReturnType<typeof useAdminOrphanedActionsLazyQuery>;
export type AdminOrphanedActionsQueryResult = Apollo.QueryResult<AdminOrphanedActionsQuery, AdminOrphanedActionsQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    success
    errorMessage
    role {
      id
      name
      description
      color
      iconUrl
      isSystem
    }
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: UUID!, $input: UpdateRoleInput!) {
  updateRole(id: $id, input: $input) {
    success
    errorMessage
    role {
      id
      name
      description
      color
      iconUrl
      isSystem
    }
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: UUID!) {
  deleteRole(id: $id) {
    success
    errorMessage
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const AssignActionToRoleDocument = gql`
    mutation AssignActionToRole($roleId: UUID!, $actionKey: String!) {
  assignActionToRole(roleId: $roleId, actionKey: $actionKey) {
    success
    errorMessage
  }
}
    `;
export type AssignActionToRoleMutationFn = Apollo.MutationFunction<AssignActionToRoleMutation, AssignActionToRoleMutationVariables>;

/**
 * __useAssignActionToRoleMutation__
 *
 * To run a mutation, you first call `useAssignActionToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignActionToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignActionToRoleMutation, { data, loading, error }] = useAssignActionToRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      actionKey: // value for 'actionKey'
 *   },
 * });
 */
export function useAssignActionToRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignActionToRoleMutation, AssignActionToRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignActionToRoleMutation, AssignActionToRoleMutationVariables>(AssignActionToRoleDocument, options);
      }
export type AssignActionToRoleMutationHookResult = ReturnType<typeof useAssignActionToRoleMutation>;
export type AssignActionToRoleMutationResult = Apollo.MutationResult<AssignActionToRoleMutation>;
export type AssignActionToRoleMutationOptions = Apollo.BaseMutationOptions<AssignActionToRoleMutation, AssignActionToRoleMutationVariables>;
export const UnassignActionFromRoleDocument = gql`
    mutation UnassignActionFromRole($roleId: UUID!, $actionKey: String!) {
  unassignActionFromRole(roleId: $roleId, actionKey: $actionKey) {
    success
    errorMessage
  }
}
    `;
export type UnassignActionFromRoleMutationFn = Apollo.MutationFunction<UnassignActionFromRoleMutation, UnassignActionFromRoleMutationVariables>;

/**
 * __useUnassignActionFromRoleMutation__
 *
 * To run a mutation, you first call `useUnassignActionFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignActionFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignActionFromRoleMutation, { data, loading, error }] = useUnassignActionFromRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      actionKey: // value for 'actionKey'
 *   },
 * });
 */
export function useUnassignActionFromRoleMutation(baseOptions?: Apollo.MutationHookOptions<UnassignActionFromRoleMutation, UnassignActionFromRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignActionFromRoleMutation, UnassignActionFromRoleMutationVariables>(UnassignActionFromRoleDocument, options);
      }
export type UnassignActionFromRoleMutationHookResult = ReturnType<typeof useUnassignActionFromRoleMutation>;
export type UnassignActionFromRoleMutationResult = Apollo.MutationResult<UnassignActionFromRoleMutation>;
export type UnassignActionFromRoleMutationOptions = Apollo.BaseMutationOptions<UnassignActionFromRoleMutation, UnassignActionFromRoleMutationVariables>;
export const SyncDiscoveredActionsDocument = gql`
    mutation SyncDiscoveredActions {
  syncDiscoveredActions {
    created {
      key
      description
      category
    }
    alreadyExist
    totalDiscovered
  }
}
    `;
export type SyncDiscoveredActionsMutationFn = Apollo.MutationFunction<SyncDiscoveredActionsMutation, SyncDiscoveredActionsMutationVariables>;

/**
 * __useSyncDiscoveredActionsMutation__
 *
 * To run a mutation, you first call `useSyncDiscoveredActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDiscoveredActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDiscoveredActionsMutation, { data, loading, error }] = useSyncDiscoveredActionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncDiscoveredActionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncDiscoveredActionsMutation, SyncDiscoveredActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDiscoveredActionsMutation, SyncDiscoveredActionsMutationVariables>(SyncDiscoveredActionsDocument, options);
      }
export type SyncDiscoveredActionsMutationHookResult = ReturnType<typeof useSyncDiscoveredActionsMutation>;
export type SyncDiscoveredActionsMutationResult = Apollo.MutationResult<SyncDiscoveredActionsMutation>;
export type SyncDiscoveredActionsMutationOptions = Apollo.BaseMutationOptions<SyncDiscoveredActionsMutation, SyncDiscoveredActionsMutationVariables>;
export const AdminSeasonListDocument = gql`
    query AdminSeasonList($skip: Int, $take: Int, $status: SeasonStatus) {
  seasons(skip: $skip, take: $take, status: $status) {
    items {
      id
      seasonNumber
      displayName
      tag
      slug
      description
      status
      startsAt
      endsAt
      visibleFrom
      visibleTo
      createdAt
      updatedAt
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminSeasonListQuery__
 *
 * To run a query within a React component, call `useAdminSeasonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSeasonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSeasonListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAdminSeasonListQuery(baseOptions?: Apollo.QueryHookOptions<AdminSeasonListQuery, AdminSeasonListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSeasonListQuery, AdminSeasonListQueryVariables>(AdminSeasonListDocument, options);
      }
export function useAdminSeasonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSeasonListQuery, AdminSeasonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSeasonListQuery, AdminSeasonListQueryVariables>(AdminSeasonListDocument, options);
        }
export type AdminSeasonListQueryHookResult = ReturnType<typeof useAdminSeasonListQuery>;
export type AdminSeasonListLazyQueryHookResult = ReturnType<typeof useAdminSeasonListLazyQuery>;
export type AdminSeasonListQueryResult = Apollo.QueryResult<AdminSeasonListQuery, AdminSeasonListQueryVariables>;
export const AdminSeasonByIdDocument = gql`
    query AdminSeasonById($id: UUID!) {
  season(id: $id) {
    id
    seasonNumber
    displayName
    tag
    slug
    description
    status
    startsAt
    endsAt
    visibleFrom
    visibleTo
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminSeasonByIdQuery__
 *
 * To run a query within a React component, call `useAdminSeasonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSeasonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSeasonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminSeasonByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminSeasonByIdQuery, AdminSeasonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSeasonByIdQuery, AdminSeasonByIdQueryVariables>(AdminSeasonByIdDocument, options);
      }
export function useAdminSeasonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSeasonByIdQuery, AdminSeasonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSeasonByIdQuery, AdminSeasonByIdQueryVariables>(AdminSeasonByIdDocument, options);
        }
export type AdminSeasonByIdQueryHookResult = ReturnType<typeof useAdminSeasonByIdQuery>;
export type AdminSeasonByIdLazyQueryHookResult = ReturnType<typeof useAdminSeasonByIdLazyQuery>;
export type AdminSeasonByIdQueryResult = Apollo.QueryResult<AdminSeasonByIdQuery, AdminSeasonByIdQueryVariables>;
export const CurrentSeasonDocument = gql`
    query CurrentSeason {
  currentSeason {
    id
    seasonNumber
    displayName
    tag
    status
    startsAt
    endsAt
  }
}
    `;

/**
 * __useCurrentSeasonQuery__
 *
 * To run a query within a React component, call `useCurrentSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSeasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSeasonQuery(baseOptions?: Apollo.QueryHookOptions<CurrentSeasonQuery, CurrentSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentSeasonQuery, CurrentSeasonQueryVariables>(CurrentSeasonDocument, options);
      }
export function useCurrentSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentSeasonQuery, CurrentSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentSeasonQuery, CurrentSeasonQueryVariables>(CurrentSeasonDocument, options);
        }
export type CurrentSeasonQueryHookResult = ReturnType<typeof useCurrentSeasonQuery>;
export type CurrentSeasonLazyQueryHookResult = ReturnType<typeof useCurrentSeasonLazyQuery>;
export type CurrentSeasonQueryResult = Apollo.QueryResult<CurrentSeasonQuery, CurrentSeasonQueryVariables>;
export const CreateSeasonDocument = gql`
    mutation CreateSeason($input: CreateSeasonInput!) {
  createSeason(input: $input) {
    id
    seasonNumber
    displayName
    tag
    slug
    status
    startsAt
    endsAt
  }
}
    `;
export type CreateSeasonMutationFn = Apollo.MutationFunction<CreateSeasonMutation, CreateSeasonMutationVariables>;

/**
 * __useCreateSeasonMutation__
 *
 * To run a mutation, you first call `useCreateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonMutation, { data, loading, error }] = useCreateSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeasonMutation, CreateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeasonMutation, CreateSeasonMutationVariables>(CreateSeasonDocument, options);
      }
export type CreateSeasonMutationHookResult = ReturnType<typeof useCreateSeasonMutation>;
export type CreateSeasonMutationResult = Apollo.MutationResult<CreateSeasonMutation>;
export type CreateSeasonMutationOptions = Apollo.BaseMutationOptions<CreateSeasonMutation, CreateSeasonMutationVariables>;
export const UpdateSeasonDocument = gql`
    mutation UpdateSeason($input: UpdateSeasonInput!) {
  updateSeason(input: $input) {
    id
    seasonNumber
    displayName
    tag
    slug
    description
    status
    startsAt
    endsAt
    visibleFrom
    visibleTo
  }
}
    `;
export type UpdateSeasonMutationFn = Apollo.MutationFunction<UpdateSeasonMutation, UpdateSeasonMutationVariables>;

/**
 * __useUpdateSeasonMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonMutation, { data, loading, error }] = useUpdateSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeasonMutation, UpdateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeasonMutation, UpdateSeasonMutationVariables>(UpdateSeasonDocument, options);
      }
export type UpdateSeasonMutationHookResult = ReturnType<typeof useUpdateSeasonMutation>;
export type UpdateSeasonMutationResult = Apollo.MutationResult<UpdateSeasonMutation>;
export type UpdateSeasonMutationOptions = Apollo.BaseMutationOptions<UpdateSeasonMutation, UpdateSeasonMutationVariables>;
export const PublishSeasonDocument = gql`
    mutation PublishSeason($id: UUID!) {
  publishSeason(id: $id)
}
    `;
export type PublishSeasonMutationFn = Apollo.MutationFunction<PublishSeasonMutation, PublishSeasonMutationVariables>;

/**
 * __usePublishSeasonMutation__
 *
 * To run a mutation, you first call `usePublishSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSeasonMutation, { data, loading, error }] = usePublishSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishSeasonMutation(baseOptions?: Apollo.MutationHookOptions<PublishSeasonMutation, PublishSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishSeasonMutation, PublishSeasonMutationVariables>(PublishSeasonDocument, options);
      }
export type PublishSeasonMutationHookResult = ReturnType<typeof usePublishSeasonMutation>;
export type PublishSeasonMutationResult = Apollo.MutationResult<PublishSeasonMutation>;
export type PublishSeasonMutationOptions = Apollo.BaseMutationOptions<PublishSeasonMutation, PublishSeasonMutationVariables>;
export const ActivateSeasonDocument = gql`
    mutation ActivateSeason($id: UUID!) {
  activateSeason(id: $id)
}
    `;
export type ActivateSeasonMutationFn = Apollo.MutationFunction<ActivateSeasonMutation, ActivateSeasonMutationVariables>;

/**
 * __useActivateSeasonMutation__
 *
 * To run a mutation, you first call `useActivateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSeasonMutation, { data, loading, error }] = useActivateSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSeasonMutation, ActivateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSeasonMutation, ActivateSeasonMutationVariables>(ActivateSeasonDocument, options);
      }
export type ActivateSeasonMutationHookResult = ReturnType<typeof useActivateSeasonMutation>;
export type ActivateSeasonMutationResult = Apollo.MutationResult<ActivateSeasonMutation>;
export type ActivateSeasonMutationOptions = Apollo.BaseMutationOptions<ActivateSeasonMutation, ActivateSeasonMutationVariables>;
export const ConcludeSeasonDocument = gql`
    mutation ConcludeSeason($id: UUID!) {
  concludeSeason(id: $id)
}
    `;
export type ConcludeSeasonMutationFn = Apollo.MutationFunction<ConcludeSeasonMutation, ConcludeSeasonMutationVariables>;

/**
 * __useConcludeSeasonMutation__
 *
 * To run a mutation, you first call `useConcludeSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcludeSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concludeSeasonMutation, { data, loading, error }] = useConcludeSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConcludeSeasonMutation(baseOptions?: Apollo.MutationHookOptions<ConcludeSeasonMutation, ConcludeSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConcludeSeasonMutation, ConcludeSeasonMutationVariables>(ConcludeSeasonDocument, options);
      }
export type ConcludeSeasonMutationHookResult = ReturnType<typeof useConcludeSeasonMutation>;
export type ConcludeSeasonMutationResult = Apollo.MutationResult<ConcludeSeasonMutation>;
export type ConcludeSeasonMutationOptions = Apollo.BaseMutationOptions<ConcludeSeasonMutation, ConcludeSeasonMutationVariables>;
export const ArchiveSeasonDocument = gql`
    mutation ArchiveSeason($id: UUID!) {
  archiveSeason(id: $id)
}
    `;
export type ArchiveSeasonMutationFn = Apollo.MutationFunction<ArchiveSeasonMutation, ArchiveSeasonMutationVariables>;

/**
 * __useArchiveSeasonMutation__
 *
 * To run a mutation, you first call `useArchiveSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSeasonMutation, { data, loading, error }] = useArchiveSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveSeasonMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSeasonMutation, ArchiveSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSeasonMutation, ArchiveSeasonMutationVariables>(ArchiveSeasonDocument, options);
      }
export type ArchiveSeasonMutationHookResult = ReturnType<typeof useArchiveSeasonMutation>;
export type ArchiveSeasonMutationResult = Apollo.MutationResult<ArchiveSeasonMutation>;
export type ArchiveSeasonMutationOptions = Apollo.BaseMutationOptions<ArchiveSeasonMutation, ArchiveSeasonMutationVariables>;
export const AdminSessionListDocument = gql`
    query AdminSessionList($userId: UUID, $isActive: Boolean) {
  listSessions(userId: $userId, isActive: $isActive) {
    seqId
    isActive
    token
    ttlMinutes
    createdAt
    userId
    lastAccessedAt
    revokedAt
    deviceId
    sessionDetails {
      ipAddress
      userAgent
    }
  }
}
    `;

/**
 * __useAdminSessionListQuery__
 *
 * To run a query within a React component, call `useAdminSessionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSessionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSessionListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useAdminSessionListQuery(baseOptions?: Apollo.QueryHookOptions<AdminSessionListQuery, AdminSessionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSessionListQuery, AdminSessionListQueryVariables>(AdminSessionListDocument, options);
      }
export function useAdminSessionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSessionListQuery, AdminSessionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSessionListQuery, AdminSessionListQueryVariables>(AdminSessionListDocument, options);
        }
export type AdminSessionListQueryHookResult = ReturnType<typeof useAdminSessionListQuery>;
export type AdminSessionListLazyQueryHookResult = ReturnType<typeof useAdminSessionListLazyQuery>;
export type AdminSessionListQueryResult = Apollo.QueryResult<AdminSessionListQuery, AdminSessionListQueryVariables>;
export const RevokeRefreshTokenDocument = gql`
    mutation RevokeRefreshToken($refreshToken: String!) {
  revokeRefreshToken(refreshToken: $refreshToken)
}
    `;
export type RevokeRefreshTokenMutationFn = Apollo.MutationFunction<RevokeRefreshTokenMutation, RevokeRefreshTokenMutationVariables>;

/**
 * __useRevokeRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRevokeRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeRefreshTokenMutation, { data, loading, error }] = useRevokeRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRevokeRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeRefreshTokenMutation, RevokeRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeRefreshTokenMutation, RevokeRefreshTokenMutationVariables>(RevokeRefreshTokenDocument, options);
      }
export type RevokeRefreshTokenMutationHookResult = ReturnType<typeof useRevokeRefreshTokenMutation>;
export type RevokeRefreshTokenMutationResult = Apollo.MutationResult<RevokeRefreshTokenMutation>;
export type RevokeRefreshTokenMutationOptions = Apollo.BaseMutationOptions<RevokeRefreshTokenMutation, RevokeRefreshTokenMutationVariables>;
export const GetPublicSettingsDocument = gql`
    query GetPublicSettings {
  publicSettings {
    path
    value
    dataType
    visibility
    description
    modifiedAt
  }
}
    `;

/**
 * __useGetPublicSettingsQuery__
 *
 * To run a query within a React component, call `useGetPublicSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>(GetPublicSettingsDocument, options);
      }
export function useGetPublicSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>(GetPublicSettingsDocument, options);
        }
export type GetPublicSettingsQueryHookResult = ReturnType<typeof useGetPublicSettingsQuery>;
export type GetPublicSettingsLazyQueryHookResult = ReturnType<typeof useGetPublicSettingsLazyQuery>;
export type GetPublicSettingsQueryResult = Apollo.QueryResult<GetPublicSettingsQuery, GetPublicSettingsQueryVariables>;
export const GetSettingDocument = gql`
    query GetSetting($path: String!) {
  setting(path: $path) {
    path
    value
    dataType
    visibility
    description
    modifiedAt
    createdAt
  }
}
    `;

/**
 * __useGetSettingQuery__
 *
 * To run a query within a React component, call `useGetSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetSettingQuery(baseOptions: Apollo.QueryHookOptions<GetSettingQuery, GetSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingQuery, GetSettingQueryVariables>(GetSettingDocument, options);
      }
export function useGetSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingQuery, GetSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingQuery, GetSettingQueryVariables>(GetSettingDocument, options);
        }
export type GetSettingQueryHookResult = ReturnType<typeof useGetSettingQuery>;
export type GetSettingLazyQueryHookResult = ReturnType<typeof useGetSettingLazyQuery>;
export type GetSettingQueryResult = Apollo.QueryResult<GetSettingQuery, GetSettingQueryVariables>;
export const GetSettingsDocument = gql`
    query GetSettings($paths: [String!]!) {
  settings(paths: $paths) {
    path
    value
    dataType
    visibility
    description
    modifiedAt
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *      paths: // value for 'paths'
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const GetSettingsByPathDocument = gql`
    query GetSettingsByPath($pathPrefix: String!, $depth: Int) {
  settingsByPath(pathPrefix: $pathPrefix, depth: $depth) {
    path
    value
    dataType
    visibility
    description
    modifiedAt
  }
}
    `;

/**
 * __useGetSettingsByPathQuery__
 *
 * To run a query within a React component, call `useGetSettingsByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsByPathQuery({
 *   variables: {
 *      pathPrefix: // value for 'pathPrefix'
 *      depth: // value for 'depth'
 *   },
 * });
 */
export function useGetSettingsByPathQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsByPathQuery, GetSettingsByPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsByPathQuery, GetSettingsByPathQueryVariables>(GetSettingsByPathDocument, options);
      }
export function useGetSettingsByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsByPathQuery, GetSettingsByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsByPathQuery, GetSettingsByPathQueryVariables>(GetSettingsByPathDocument, options);
        }
export type GetSettingsByPathQueryHookResult = ReturnType<typeof useGetSettingsByPathQuery>;
export type GetSettingsByPathLazyQueryHookResult = ReturnType<typeof useGetSettingsByPathLazyQuery>;
export type GetSettingsByPathQueryResult = Apollo.QueryResult<GetSettingsByPathQuery, GetSettingsByPathQueryVariables>;
export const ListAllSettingsDocument = gql`
    query ListAllSettings($skip: Int, $take: Int) {
  listAllSettings(skip: $skip, take: $take) {
    items {
      path
      value
      dataType
      visibility
      description
      modifiedAt
      createdAt
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useListAllSettingsQuery__
 *
 * To run a query within a React component, call `useListAllSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllSettingsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useListAllSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllSettingsQuery, ListAllSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllSettingsQuery, ListAllSettingsQueryVariables>(ListAllSettingsDocument, options);
      }
export function useListAllSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllSettingsQuery, ListAllSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllSettingsQuery, ListAllSettingsQueryVariables>(ListAllSettingsDocument, options);
        }
export type ListAllSettingsQueryHookResult = ReturnType<typeof useListAllSettingsQuery>;
export type ListAllSettingsLazyQueryHookResult = ReturnType<typeof useListAllSettingsLazyQuery>;
export type ListAllSettingsQueryResult = Apollo.QueryResult<ListAllSettingsQuery, ListAllSettingsQueryVariables>;
export const UpsertSettingDocument = gql`
    mutation UpsertSetting($input: UpsertSettingInput!) {
  settings {
    upsertSetting(input: $input) {
      path
      value
      dataType
      visibility
      description
      modifiedAt
    }
  }
}
    `;
export type UpsertSettingMutationFn = Apollo.MutationFunction<UpsertSettingMutation, UpsertSettingMutationVariables>;

/**
 * __useUpsertSettingMutation__
 *
 * To run a mutation, you first call `useUpsertSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSettingMutation, { data, loading, error }] = useUpsertSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSettingMutation, UpsertSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSettingMutation, UpsertSettingMutationVariables>(UpsertSettingDocument, options);
      }
export type UpsertSettingMutationHookResult = ReturnType<typeof useUpsertSettingMutation>;
export type UpsertSettingMutationResult = Apollo.MutationResult<UpsertSettingMutation>;
export type UpsertSettingMutationOptions = Apollo.BaseMutationOptions<UpsertSettingMutation, UpsertSettingMutationVariables>;
export const DeleteSettingDocument = gql`
    mutation DeleteSetting($path: String!) {
  settings {
    deleteSetting(path: $path)
  }
}
    `;
export type DeleteSettingMutationFn = Apollo.MutationFunction<DeleteSettingMutation, DeleteSettingMutationVariables>;

/**
 * __useDeleteSettingMutation__
 *
 * To run a mutation, you first call `useDeleteSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingMutation, { data, loading, error }] = useDeleteSettingMutation({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useDeleteSettingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSettingMutation, DeleteSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSettingMutation, DeleteSettingMutationVariables>(DeleteSettingDocument, options);
      }
export type DeleteSettingMutationHookResult = ReturnType<typeof useDeleteSettingMutation>;
export type DeleteSettingMutationResult = Apollo.MutationResult<DeleteSettingMutation>;
export type DeleteSettingMutationOptions = Apollo.BaseMutationOptions<DeleteSettingMutation, DeleteSettingMutationVariables>;
export const BulkUpsertSettingsDocument = gql`
    mutation BulkUpsertSettings($settings: [UpsertSettingInput!]!) {
  settings {
    bulkUpsertSettings(settings: $settings) {
      path
      value
      dataType
    }
  }
}
    `;
export type BulkUpsertSettingsMutationFn = Apollo.MutationFunction<BulkUpsertSettingsMutation, BulkUpsertSettingsMutationVariables>;

/**
 * __useBulkUpsertSettingsMutation__
 *
 * To run a mutation, you first call `useBulkUpsertSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpsertSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpsertSettingsMutation, { data, loading, error }] = useBulkUpsertSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useBulkUpsertSettingsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpsertSettingsMutation, BulkUpsertSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpsertSettingsMutation, BulkUpsertSettingsMutationVariables>(BulkUpsertSettingsDocument, options);
      }
export type BulkUpsertSettingsMutationHookResult = ReturnType<typeof useBulkUpsertSettingsMutation>;
export type BulkUpsertSettingsMutationResult = Apollo.MutationResult<BulkUpsertSettingsMutation>;
export type BulkUpsertSettingsMutationOptions = Apollo.BaseMutationOptions<BulkUpsertSettingsMutation, BulkUpsertSettingsMutationVariables>;
export const ListTeamsDocument = gql`
    query ListTeams($skip: Int, $take: Int, $where: TeamFilterInput, $order: [TeamSortInput!]) {
  teams(skip: $skip, take: $take, where: $where, order: $order) {
    items {
      id
      name
      active
      franchiseId
      franchise {
        id
        name
        prefix
        logoUrl
      }
      players {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useListTeamsQuery__
 *
 * To run a query within a React component, call `useListTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListTeamsQuery(baseOptions?: Apollo.QueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
      }
export function useListTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamsQuery, ListTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamsQuery, ListTeamsQueryVariables>(ListTeamsDocument, options);
        }
export type ListTeamsQueryHookResult = ReturnType<typeof useListTeamsQuery>;
export type ListTeamsLazyQueryHookResult = ReturnType<typeof useListTeamsLazyQuery>;
export type ListTeamsQueryResult = Apollo.QueryResult<ListTeamsQuery, ListTeamsQueryVariables>;
export const TeamDetailsDocument = gql`
    query TeamDetails($teamId: UUID!) {
  team(id: $teamId) {
    id
    name
    active
    tier
    franchiseId
    franchise {
      id
      name
      prefix
      logoUrl
      GM {
        id
        name
      }
      AGM {
        id
        name
      }
    }
    players {
      id
      name
      avatarUrl
      mmr
      roles
      isCaptain
    }
  }
}
    `;

/**
 * __useTeamDetailsQuery__
 *
 * To run a query within a React component, call `useTeamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDetailsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamDetailsQuery(baseOptions: Apollo.QueryHookOptions<TeamDetailsQuery, TeamDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamDetailsQuery, TeamDetailsQueryVariables>(TeamDetailsDocument, options);
      }
export function useTeamDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamDetailsQuery, TeamDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamDetailsQuery, TeamDetailsQueryVariables>(TeamDetailsDocument, options);
        }
export type TeamDetailsQueryHookResult = ReturnType<typeof useTeamDetailsQuery>;
export type TeamDetailsLazyQueryHookResult = ReturnType<typeof useTeamDetailsLazyQuery>;
export type TeamDetailsQueryResult = Apollo.QueryResult<TeamDetailsQuery, TeamDetailsQueryVariables>;
export const UserTeamsDocument = gql`
    query UserTeams($userId: UUID!) {
  teams(where: {players: {some: {id: {equals: $userId}}}}) {
    items {
      id
      name
      tier
      franchise {
        id
        name
        prefix
        logoUrl
      }
    }
    totalCount
  }
}
    `;

/**
 * __useUserTeamsQuery__
 *
 * To run a query within a React component, call `useUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTeamsQuery(baseOptions: Apollo.QueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
      }
export function useUserTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
        }
export type UserTeamsQueryHookResult = ReturnType<typeof useUserTeamsQuery>;
export type UserTeamsLazyQueryHookResult = ReturnType<typeof useUserTeamsLazyQuery>;
export type UserTeamsQueryResult = Apollo.QueryResult<UserTeamsQuery, UserTeamsQueryVariables>;
export const AddTeamDocument = gql`
    mutation AddTeam($franchiseId: UUID!, $teamName: String!) {
  addTeam(franchiseId: $franchiseId, teamName: $teamName) {
    id
    name
    active
    franchiseId
    franchise {
      id
      name
      prefix
    }
  }
}
    `;
export type AddTeamMutationFn = Apollo.MutationFunction<AddTeamMutation, AddTeamMutationVariables>;

/**
 * __useAddTeamMutation__
 *
 * To run a mutation, you first call `useAddTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMutation, { data, loading, error }] = useAddTeamMutation({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAddTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMutation, AddTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMutation, AddTeamMutationVariables>(AddTeamDocument, options);
      }
export type AddTeamMutationHookResult = ReturnType<typeof useAddTeamMutation>;
export type AddTeamMutationResult = Apollo.MutationResult<AddTeamMutation>;
export type AddTeamMutationOptions = Apollo.BaseMutationOptions<AddTeamMutation, AddTeamMutationVariables>;
export const UpdateTeamNameDocument = gql`
    mutation UpdateTeamName($teamId: UUID!, $teamName: String!) {
  updateTeamName(teamId: $teamId, teamName: $teamName) {
    id
    name
    active
    franchiseId
    franchise {
      id
      name
      prefix
    }
  }
}
    `;
export type UpdateTeamNameMutationFn = Apollo.MutationFunction<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>;

/**
 * __useUpdateTeamNameMutation__
 *
 * To run a mutation, you first call `useUpdateTeamNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamNameMutation, { data, loading, error }] = useUpdateTeamNameMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useUpdateTeamNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>(UpdateTeamNameDocument, options);
      }
export type UpdateTeamNameMutationHookResult = ReturnType<typeof useUpdateTeamNameMutation>;
export type UpdateTeamNameMutationResult = Apollo.MutationResult<UpdateTeamNameMutation>;
export type UpdateTeamNameMutationOptions = Apollo.BaseMutationOptions<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>;
export const SetTeamActiveDocument = gql`
    mutation SetTeamActive($teamId: UUID!, $active: Boolean!) {
  setTeamActive(teamId: $teamId, active: $active) {
    id
    name
    active
    franchiseId
    franchise {
      id
      name
      prefix
    }
  }
}
    `;
export type SetTeamActiveMutationFn = Apollo.MutationFunction<SetTeamActiveMutation, SetTeamActiveMutationVariables>;

/**
 * __useSetTeamActiveMutation__
 *
 * To run a mutation, you first call `useSetTeamActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamActiveMutation, { data, loading, error }] = useSetTeamActiveMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetTeamActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamActiveMutation, SetTeamActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamActiveMutation, SetTeamActiveMutationVariables>(SetTeamActiveDocument, options);
      }
export type SetTeamActiveMutationHookResult = ReturnType<typeof useSetTeamActiveMutation>;
export type SetTeamActiveMutationResult = Apollo.MutationResult<SetTeamActiveMutation>;
export type SetTeamActiveMutationOptions = Apollo.BaseMutationOptions<SetTeamActiveMutation, SetTeamActiveMutationVariables>;
export const AddPlayerToTeamDocument = gql`
    mutation AddPlayerToTeam($teamId: UUID!, $userId: UUID!) {
  addPlayerToTeam(teamId: $teamId, userId: $userId) {
    id
    name
    players {
      id
      name
      avatarUrl
      isCaptain
    }
  }
}
    `;
export type AddPlayerToTeamMutationFn = Apollo.MutationFunction<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>;

/**
 * __useAddPlayerToTeamMutation__
 *
 * To run a mutation, you first call `useAddPlayerToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlayerToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlayerToTeamMutation, { data, loading, error }] = useAddPlayerToTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddPlayerToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>(AddPlayerToTeamDocument, options);
      }
export type AddPlayerToTeamMutationHookResult = ReturnType<typeof useAddPlayerToTeamMutation>;
export type AddPlayerToTeamMutationResult = Apollo.MutationResult<AddPlayerToTeamMutation>;
export type AddPlayerToTeamMutationOptions = Apollo.BaseMutationOptions<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>;
export const RemovePlayerFromTeamDocument = gql`
    mutation RemovePlayerFromTeam($teamId: UUID!, $userId: UUID!) {
  removePlayerFromTeam(teamId: $teamId, userId: $userId) {
    id
    name
    players {
      id
      name
      avatarUrl
      isCaptain
    }
  }
}
    `;
export type RemovePlayerFromTeamMutationFn = Apollo.MutationFunction<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>;

/**
 * __useRemovePlayerFromTeamMutation__
 *
 * To run a mutation, you first call `useRemovePlayerFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlayerFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlayerFromTeamMutation, { data, loading, error }] = useRemovePlayerFromTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePlayerFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>(RemovePlayerFromTeamDocument, options);
      }
export type RemovePlayerFromTeamMutationHookResult = ReturnType<typeof useRemovePlayerFromTeamMutation>;
export type RemovePlayerFromTeamMutationResult = Apollo.MutationResult<RemovePlayerFromTeamMutation>;
export type RemovePlayerFromTeamMutationOptions = Apollo.BaseMutationOptions<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>;
export const SetTeamCaptainDocument = gql`
    mutation SetTeamCaptain($teamId: UUID!, $userId: UUID) {
  setTeamCaptain(teamId: $teamId, userId: $userId) {
    id
    name
    players {
      id
      name
      isCaptain
    }
  }
}
    `;
export type SetTeamCaptainMutationFn = Apollo.MutationFunction<SetTeamCaptainMutation, SetTeamCaptainMutationVariables>;

/**
 * __useSetTeamCaptainMutation__
 *
 * To run a mutation, you first call `useSetTeamCaptainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamCaptainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamCaptainMutation, { data, loading, error }] = useSetTeamCaptainMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetTeamCaptainMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamCaptainMutation, SetTeamCaptainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamCaptainMutation, SetTeamCaptainMutationVariables>(SetTeamCaptainDocument, options);
      }
export type SetTeamCaptainMutationHookResult = ReturnType<typeof useSetTeamCaptainMutation>;
export type SetTeamCaptainMutationResult = Apollo.MutationResult<SetTeamCaptainMutation>;
export type SetTeamCaptainMutationOptions = Apollo.BaseMutationOptions<SetTeamCaptainMutation, SetTeamCaptainMutationVariables>;
export const PendingLeagueStaffApprovalsDocument = gql`
    query PendingLeagueStaffApprovals($skip: Int, $take: Int, $where: TransactionFilterInput, $order: [TransactionSortInput!]) {
  pendingLeagueStaffApprovals(
    skip: $skip
    take: $take
    where: $where
    order: $order
  ) {
    items {
      ...TransactionFields
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __usePendingLeagueStaffApprovalsQuery__
 *
 * To run a query within a React component, call `usePendingLeagueStaffApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingLeagueStaffApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingLeagueStaffApprovalsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePendingLeagueStaffApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<PendingLeagueStaffApprovalsQuery, PendingLeagueStaffApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingLeagueStaffApprovalsQuery, PendingLeagueStaffApprovalsQueryVariables>(PendingLeagueStaffApprovalsDocument, options);
      }
export function usePendingLeagueStaffApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingLeagueStaffApprovalsQuery, PendingLeagueStaffApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingLeagueStaffApprovalsQuery, PendingLeagueStaffApprovalsQueryVariables>(PendingLeagueStaffApprovalsDocument, options);
        }
export type PendingLeagueStaffApprovalsQueryHookResult = ReturnType<typeof usePendingLeagueStaffApprovalsQuery>;
export type PendingLeagueStaffApprovalsLazyQueryHookResult = ReturnType<typeof usePendingLeagueStaffApprovalsLazyQuery>;
export type PendingLeagueStaffApprovalsQueryResult = Apollo.QueryResult<PendingLeagueStaffApprovalsQuery, PendingLeagueStaffApprovalsQueryVariables>;
export const TransactionDetailsDocument = gql`
    query TransactionDetails($transactionId: UUID!) {
  transaction(id: $transactionId) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useTransactionDetailsQuery__
 *
 * To run a query within a React component, call `useTransactionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionDetailsQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useTransactionDetailsQuery(baseOptions: Apollo.QueryHookOptions<TransactionDetailsQuery, TransactionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionDetailsQuery, TransactionDetailsQueryVariables>(TransactionDetailsDocument, options);
      }
export function useTransactionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionDetailsQuery, TransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionDetailsQuery, TransactionDetailsQueryVariables>(TransactionDetailsDocument, options);
        }
export type TransactionDetailsQueryHookResult = ReturnType<typeof useTransactionDetailsQuery>;
export type TransactionDetailsLazyQueryHookResult = ReturnType<typeof useTransactionDetailsLazyQuery>;
export type TransactionDetailsQueryResult = Apollo.QueryResult<TransactionDetailsQuery, TransactionDetailsQueryVariables>;
export const PendingTransactionsDocument = gql`
    query PendingTransactions($skip: Int, $take: Int, $franchiseId: UUID, $where: TransactionFilterInput, $order: [TransactionSortInput!]) {
  pendingTransactions(
    skip: $skip
    take: $take
    franchiseId: $franchiseId
    where: $where
    order: $order
  ) {
    items {
      ...TransactionFields
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __usePendingTransactionsQuery__
 *
 * To run a query within a React component, call `usePendingTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingTransactionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      franchiseId: // value for 'franchiseId'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePendingTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<PendingTransactionsQuery, PendingTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingTransactionsQuery, PendingTransactionsQueryVariables>(PendingTransactionsDocument, options);
      }
export function usePendingTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingTransactionsQuery, PendingTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingTransactionsQuery, PendingTransactionsQueryVariables>(PendingTransactionsDocument, options);
        }
export type PendingTransactionsQueryHookResult = ReturnType<typeof usePendingTransactionsQuery>;
export type PendingTransactionsLazyQueryHookResult = ReturnType<typeof usePendingTransactionsLazyQuery>;
export type PendingTransactionsQueryResult = Apollo.QueryResult<PendingTransactionsQuery, PendingTransactionsQueryVariables>;
export const PendingFranchiseApprovalsDocument = gql`
    query PendingFranchiseApprovals($franchiseId: UUID!, $skip: Int, $take: Int, $where: TransactionFilterInput, $order: [TransactionSortInput!]) {
  pendingFranchiseApprovals(
    franchiseId: $franchiseId
    skip: $skip
    take: $take
    where: $where
    order: $order
  ) {
    items {
      ...TransactionFields
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __usePendingFranchiseApprovalsQuery__
 *
 * To run a query within a React component, call `usePendingFranchiseApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingFranchiseApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingFranchiseApprovalsQuery({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePendingFranchiseApprovalsQuery(baseOptions: Apollo.QueryHookOptions<PendingFranchiseApprovalsQuery, PendingFranchiseApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingFranchiseApprovalsQuery, PendingFranchiseApprovalsQueryVariables>(PendingFranchiseApprovalsDocument, options);
      }
export function usePendingFranchiseApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingFranchiseApprovalsQuery, PendingFranchiseApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingFranchiseApprovalsQuery, PendingFranchiseApprovalsQueryVariables>(PendingFranchiseApprovalsDocument, options);
        }
export type PendingFranchiseApprovalsQueryHookResult = ReturnType<typeof usePendingFranchiseApprovalsQuery>;
export type PendingFranchiseApprovalsLazyQueryHookResult = ReturnType<typeof usePendingFranchiseApprovalsLazyQuery>;
export type PendingFranchiseApprovalsQueryResult = Apollo.QueryResult<PendingFranchiseApprovalsQuery, PendingFranchiseApprovalsQueryVariables>;
export const ExecutedTransactionsDocument = gql`
    query ExecutedTransactions($skip: Int, $take: Int, $franchiseId: UUID, $where: TransactionFilterInput, $order: [TransactionSortInput!]) {
  transactions(
    skip: $skip
    take: $take
    franchiseId: $franchiseId
    where: $where
    order: $order
  ) {
    items {
      id
      transactionType
      dateSubmitted
      dateExecuted
      notes
      submitter {
        id
        name
        avatarUrl
      }
      submittingFranchise {
        id
        name
        prefix
      }
      tradePartnerFranchise {
        id
        name
        prefix
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useExecutedTransactionsQuery__
 *
 * To run a query within a React component, call `useExecutedTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutedTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutedTransactionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      franchiseId: // value for 'franchiseId'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useExecutedTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<ExecutedTransactionsQuery, ExecutedTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecutedTransactionsQuery, ExecutedTransactionsQueryVariables>(ExecutedTransactionsDocument, options);
      }
export function useExecutedTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecutedTransactionsQuery, ExecutedTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecutedTransactionsQuery, ExecutedTransactionsQueryVariables>(ExecutedTransactionsDocument, options);
        }
export type ExecutedTransactionsQueryHookResult = ReturnType<typeof useExecutedTransactionsQuery>;
export type ExecutedTransactionsLazyQueryHookResult = ReturnType<typeof useExecutedTransactionsLazyQuery>;
export type ExecutedTransactionsQueryResult = Apollo.QueryResult<ExecutedTransactionsQuery, ExecutedTransactionsQueryVariables>;
export const SetTransactionApprovalStatusDocument = gql`
    mutation SetTransactionApprovalStatus($input: SetTransactionApprovalInput!) {
  setTransactionApprovalStatus(input: $input) {
    id
    approvalStatus
    approvalDate
    notes
    approver {
      id
      name
    }
  }
}
    `;
export type SetTransactionApprovalStatusMutationFn = Apollo.MutationFunction<SetTransactionApprovalStatusMutation, SetTransactionApprovalStatusMutationVariables>;

/**
 * __useSetTransactionApprovalStatusMutation__
 *
 * To run a mutation, you first call `useSetTransactionApprovalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTransactionApprovalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTransactionApprovalStatusMutation, { data, loading, error }] = useSetTransactionApprovalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTransactionApprovalStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTransactionApprovalStatusMutation, SetTransactionApprovalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTransactionApprovalStatusMutation, SetTransactionApprovalStatusMutationVariables>(SetTransactionApprovalStatusDocument, options);
      }
export type SetTransactionApprovalStatusMutationHookResult = ReturnType<typeof useSetTransactionApprovalStatusMutation>;
export type SetTransactionApprovalStatusMutationResult = Apollo.MutationResult<SetTransactionApprovalStatusMutation>;
export type SetTransactionApprovalStatusMutationOptions = Apollo.BaseMutationOptions<SetTransactionApprovalStatusMutation, SetTransactionApprovalStatusMutationVariables>;
export const ExecuteTransactionDocument = gql`
    mutation ExecuteTransaction($transactionId: UUID!) {
  executeTransaction(transactionId: $transactionId) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type ExecuteTransactionMutationFn = Apollo.MutationFunction<ExecuteTransactionMutation, ExecuteTransactionMutationVariables>;

/**
 * __useExecuteTransactionMutation__
 *
 * To run a mutation, you first call `useExecuteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeTransactionMutation, { data, loading, error }] = useExecuteTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useExecuteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteTransactionMutation, ExecuteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteTransactionMutation, ExecuteTransactionMutationVariables>(ExecuteTransactionDocument, options);
      }
export type ExecuteTransactionMutationHookResult = ReturnType<typeof useExecuteTransactionMutation>;
export type ExecuteTransactionMutationResult = Apollo.MutationResult<ExecuteTransactionMutation>;
export type ExecuteTransactionMutationOptions = Apollo.BaseMutationOptions<ExecuteTransactionMutation, ExecuteTransactionMutationVariables>;
export const DeleteTransactionDocument = gql`
    mutation DeleteTransaction($transactionId: UUID!) {
  deleteTransaction(transactionId: $transactionId) {
    id
  }
}
    `;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<DeleteTransactionMutation, DeleteTransactionMutationVariables>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, options);
      }
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation CreateTransaction($input: CreateTransactionInput!) {
  createTransaction(input: $input) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const RefreshDocument = gql`
    mutation refresh($refreshToken: String!) {
  refresh(refreshToken: $refreshToken) {
    isAuthenticated
    token
    refreshToken
    user {
      id
      name
      avatarUrl
    }
  }
}
    `;
export type RefreshMutationFn = Apollo.MutationFunction<RefreshMutation, RefreshMutationVariables>;

/**
 * __useRefreshMutation__
 *
 * To run a mutation, you first call `useRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMutation, { data, loading, error }] = useRefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMutation, RefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshMutation, RefreshMutationVariables>(RefreshDocument, options);
      }
export type RefreshMutationHookResult = ReturnType<typeof useRefreshMutation>;
export type RefreshMutationResult = Apollo.MutationResult<RefreshMutation>;
export type RefreshMutationOptions = Apollo.BaseMutationOptions<RefreshMutation, RefreshMutationVariables>;
export const SignupUserDocument = gql`
    mutation SignupUser($authCode: String!, $redirectUri: String!) {
  signup(discordAuthCode: $authCode, redirectUri: $redirectUri) {
    token
    outcome
    user {
      id
      name
      avatarUrl
    }
  }
}
    `;
export type SignupUserMutationFn = Apollo.MutationFunction<SignupUserMutation, SignupUserMutationVariables>;

/**
 * __useSignupUserMutation__
 *
 * To run a mutation, you first call `useSignupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupUserMutation, { data, loading, error }] = useSignupUserMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useSignupUserMutation(baseOptions?: Apollo.MutationHookOptions<SignupUserMutation, SignupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupUserMutation, SignupUserMutationVariables>(SignupUserDocument, options);
      }
export type SignupUserMutationHookResult = ReturnType<typeof useSignupUserMutation>;
export type SignupUserMutationResult = Apollo.MutationResult<SignupUserMutation>;
export type SignupUserMutationOptions = Apollo.BaseMutationOptions<SignupUserMutation, SignupUserMutationVariables>;
export const LoginDocument = gql`
    mutation Login($authCode: String!, $redirectUri: String!) {
  login(discordAuthCode: $authCode, redirectUri: $redirectUri) {
    token
    isAuthenticated
    refreshToken
    user {
      id
      name
      avatarUrl
      roles
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    userData {
      id
      name
      avatarUrl
      roles
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($userId: UUID!) {
  user(id: $userId) {
    id
    name
    avatarUrl
    roles
    roleNames
  }
}
    `;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const AdminUserListDocument = gql`
    query AdminUserList($skip: Int, $take: Int) {
  users(skip: $skip, take: $take) {
    items {
      id
      name
      roles
      isBanned
      isSuspended
      isWatchlist
    }
    totalCount
  }
}
    `;

/**
 * __useAdminUserListQuery__
 *
 * To run a query within a React component, call `useAdminUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAdminUserListQuery(baseOptions?: Apollo.QueryHookOptions<AdminUserListQuery, AdminUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserListQuery, AdminUserListQueryVariables>(AdminUserListDocument, options);
      }
export function useAdminUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserListQuery, AdminUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserListQuery, AdminUserListQueryVariables>(AdminUserListDocument, options);
        }
export type AdminUserListQueryHookResult = ReturnType<typeof useAdminUserListQuery>;
export type AdminUserListLazyQueryHookResult = ReturnType<typeof useAdminUserListLazyQuery>;
export type AdminUserListQueryResult = Apollo.QueryResult<AdminUserListQuery, AdminUserListQueryVariables>;
export const UserSearchDocument = gql`
    query UserSearch($input: String!) {
  users(take: 15, where: {name: {contains: $input}}) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useUserSearchQuery__
 *
 * To run a query within a React component, call `useUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSearchQuery(baseOptions: Apollo.QueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
      }
export function useUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
        }
export type UserSearchQueryHookResult = ReturnType<typeof useUserSearchQuery>;
export type UserSearchLazyQueryHookResult = ReturnType<typeof useUserSearchLazyQuery>;
export type UserSearchQueryResult = Apollo.QueryResult<UserSearchQuery, UserSearchQueryVariables>;
export const AdminUserByIdDocument = gql`
    query AdminUserById($id: UUID!) {
  user(id: $id) {
    id
    name
    roles
    isBanned
    isSuspended
    isWatchlist
    assignedRoles {
      id
      name
      description
      color
      iconUrl
      isSystem
    }
    adminMemos {
      id
      text
      userId
      timestamp
      operatorLabel
      admin {
        name
      }
    }
  }
}
    `;

/**
 * __useAdminUserByIdQuery__
 *
 * To run a query within a React component, call `useAdminUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminUserByIdQuery, AdminUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserByIdQuery, AdminUserByIdQueryVariables>(AdminUserByIdDocument, options);
      }
export function useAdminUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserByIdQuery, AdminUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserByIdQuery, AdminUserByIdQueryVariables>(AdminUserByIdDocument, options);
        }
export type AdminUserByIdQueryHookResult = ReturnType<typeof useAdminUserByIdQuery>;
export type AdminUserByIdLazyQueryHookResult = ReturnType<typeof useAdminUserByIdLazyQuery>;
export type AdminUserByIdQueryResult = Apollo.QueryResult<AdminUserByIdQuery, AdminUserByIdQueryVariables>;
export const AdminAddUserMemoDocument = gql`
    mutation AdminAddUserMemo($userId: UUID!, $memo: String!) {
  addUserMemo(userId: $userId, memo: $memo)
}
    `;
export type AdminAddUserMemoMutationFn = Apollo.MutationFunction<AdminAddUserMemoMutation, AdminAddUserMemoMutationVariables>;

/**
 * __useAdminAddUserMemoMutation__
 *
 * To run a mutation, you first call `useAdminAddUserMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddUserMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddUserMemoMutation, { data, loading, error }] = useAdminAddUserMemoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      memo: // value for 'memo'
 *   },
 * });
 */
export function useAdminAddUserMemoMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddUserMemoMutation, AdminAddUserMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddUserMemoMutation, AdminAddUserMemoMutationVariables>(AdminAddUserMemoDocument, options);
      }
export type AdminAddUserMemoMutationHookResult = ReturnType<typeof useAdminAddUserMemoMutation>;
export type AdminAddUserMemoMutationResult = Apollo.MutationResult<AdminAddUserMemoMutation>;
export type AdminAddUserMemoMutationOptions = Apollo.BaseMutationOptions<AdminAddUserMemoMutation, AdminAddUserMemoMutationVariables>;
export const AdminUserMemosDocument = gql`
    query AdminUserMemos($userId: UUID!, $skip: Int, $take: Int) {
  userAdminMemos(
    userId: $userId
    skip: $skip
    take: $take
    order: {timestamp: DESC}
  ) {
    items {
      id
      text
      userId
      timestamp
      operatorLabel
      admin {
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminUserMemosQuery__
 *
 * To run a query within a React component, call `useAdminUserMemosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserMemosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserMemosQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAdminUserMemosQuery(baseOptions: Apollo.QueryHookOptions<AdminUserMemosQuery, AdminUserMemosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserMemosQuery, AdminUserMemosQueryVariables>(AdminUserMemosDocument, options);
      }
export function useAdminUserMemosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserMemosQuery, AdminUserMemosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserMemosQuery, AdminUserMemosQueryVariables>(AdminUserMemosDocument, options);
        }
export type AdminUserMemosQueryHookResult = ReturnType<typeof useAdminUserMemosQuery>;
export type AdminUserMemosLazyQueryHookResult = ReturnType<typeof useAdminUserMemosLazyQuery>;
export type AdminUserMemosQueryResult = Apollo.QueryResult<AdminUserMemosQuery, AdminUserMemosQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($skip: Int, $take: Int, $where: UserFilterInput, $order: [UserSortInput!]) {
  users(skip: $skip, take: $take, where: $where, order: $order) {
    items {
      id
      name
      avatarUrl
      roles
      roleNames
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const SetUserFlagsDocument = gql`
    mutation SetUserFlags($userId: UUID!, $isBanned: Boolean, $isSuspended: Boolean, $isWatchlist: Boolean) {
  setUserFlags(
    userId: $userId
    isBanned: $isBanned
    isSuspended: $isSuspended
    isWatchlist: $isWatchlist
  ) {
    success
    errorMessage
    user {
      id
      isBanned
      isSuspended
      isWatchlist
    }
  }
}
    `;
export type SetUserFlagsMutationFn = Apollo.MutationFunction<SetUserFlagsMutation, SetUserFlagsMutationVariables>;

/**
 * __useSetUserFlagsMutation__
 *
 * To run a mutation, you first call `useSetUserFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserFlagsMutation, { data, loading, error }] = useSetUserFlagsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isBanned: // value for 'isBanned'
 *      isSuspended: // value for 'isSuspended'
 *      isWatchlist: // value for 'isWatchlist'
 *   },
 * });
 */
export function useSetUserFlagsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserFlagsMutation, SetUserFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserFlagsMutation, SetUserFlagsMutationVariables>(SetUserFlagsDocument, options);
      }
export type SetUserFlagsMutationHookResult = ReturnType<typeof useSetUserFlagsMutation>;
export type SetUserFlagsMutationResult = Apollo.MutationResult<SetUserFlagsMutation>;
export type SetUserFlagsMutationOptions = Apollo.BaseMutationOptions<SetUserFlagsMutation, SetUserFlagsMutationVariables>;